<template>
  <div v-loading="tryingGetMember" :class="$style.orderformSection">
    <div v-if="!prepaidAllShow && !totalAllShow && !checkResultAndPayStatus" class="orderformSection__all">
      <!-- 原本抽屜的左半部分 -->
      <div v-if="!completeReserveAndPayStatus" class="orderformSection__left">
        <!-- 左半部分：預約時間＋地點＋美容師 -->
        <div v-if="!isAutoOpen && drawerOpenType.normal" :id="orderHeaderId" :class="$style.header">
          <el-alert v-if="scheduleDetail.showExpiredAlert" type="warning" :title="'請注意，您選擇的時段已經過期！'" :closable="false" style="margin-top: 0.5rem"> </el-alert>
          <div v-if="!isModified">
            <h5 class="Jost" :class="$style.title"><span class="text-text-light">預約時間：</span>{{ scheduleDetail.date | formatDate('dateTime') }}</h5>
            <h5 class="Jost"><span class="text-text-light">此時段服務地點：</span>{{ scheduleDetail.storesTitle }}</h5>
          </div>
          <div v-if="isModified">
            <h5 class="Jost" :class="$style.title"><span class="text-text-light">預約時間：</span>{{ `${modifyOrder.date} ${modifyOrder.time}` }}</h5>
            <h5 class="Jost"><span class="text-text-light">此時段服務地點：</span>{{ modifyOrder.productName }}</h5>
          </div>
          <div :class="$style.nameSpecifyDisplay">
            <h5 v-if="scheduleDetail.name" class="Jost"><span class="text-text-light">美容師：</span>{{ `${scheduleDetail.name} ${scheduleDetail.state === 0 ? '(停權中)' : ''}` }} </h5>
            <div>
              <el-radio v-model="staffSpecify" :disabled="isUseStaffPriceAdj" label="specify">指定</el-radio>
              <el-radio v-model="staffSpecify" :disabled="isUseStaffPriceAdj" label="notSpecify">不指定</el-radio>
            </div>
          </div>
        </div>
        <div v-if="!visibleMemberSearch && isAutoOpen && drawerOpenType.autoOpenForGoodsAndVisit" :class="$style.visitHeader">
          <el-button class="is-round isStyleBase" @click="clearMemberInfo">
            <BaseIcon name="arrow-left" />
            重新搜尋客戶
          </el-button>
          <h5 class="Jost" :class="$style.title"><span class="text-text-light">地點：</span>{{ scheduleDetail.storesTitle }}</h5>
          <h5 class="Jost" :class="$style.title"><span class="text-text-light">客戶：</span>{{ memberInfo.fullName }} {{ genderCheck }}</h5>
        </div>
        <div v-if="isAutoOpen && drawerOpenType.autoOpenForGoodsAndNonMember" :class="$style.fakeHeader"></div>
        <!-- <div v-if="isAutoOpen && (drawerOpenType.autoOpenForGoodsAndMember)" :class="$style.fakeHeaderForMember"></div> -->
        <!-- 左半部分：會員搜尋 -->
        <div
          ref="leftCont"
          class="orderformSection__left__content"
          :class="{
            [$style.autoOpenForGoodsAndNonMemberClass]: drawerOpenType.autoOpenForGoodsAndNonMember,
            [$style.autoOpenForGoodsAndMemberClass]: drawerOpenType.autoOpenForGoodsAndMember,
            [$style.autoOpenForGoodsAndVisitClass]: drawerOpenType.autoOpenForGoodsAndVisit,
          }"
          :style="notAutoOpenLeftContentHeight"
        >
          <!-- 搜尋會員 -->
          <template v-if="visibleMemberSearch">
            <MemberSearchForm
              :is-auto-open="isAutoOpen"
              :drawer-open-type="drawerOpenType"
              :order-type="orderType"
              @create="createMember"
              @update="tryToFetchDetail"
              @showMemberInfo="showMemberInfo"
            />
          </template>
          <!-- 會員搜尋好了 -->
          <div v-if="!visibleMemberSearch && !drawerOpenType.autoOpenForGoodsAndVisit" element-loading-background="rgba(0, 0, 0,0)" style="min-height: 300px; padding-top: 20px" class="info-section">
            <template v-if="memberInfo.id">
              <div v-if="!isModified" class="orderformSection__left__content__time">
                <el-button class="is-round" :style="{ marginBottom: isAutoOpen ? '10px' : '20px' }" @click="clearMemberInfo">
                  <BaseIcon name="arrow-left" />
                  {{ isAutoOpen ? '重新搜尋客戶' : '重新搜尋' }}
                </el-button>
                <p v-if="Object.keys(containerOrders).length > 0" class="orderformSection__left__content__timeMain">
                  <span>
                    <BaseIcon name="clock" icon-style="fal" :class="[$style['header-icon-left'], 'fs-2xl', 'mr-3', 'align-text-bottom']" />
                  </span>
                  {{ `${minutes}:${seconds} ` }}
                </p>
              </div>
              <!-- 商品模組to-do：要開啟這個 -->
              <h5 v-if="false">地點：{{ scheduleDetail.storesTitle }}</h5>
              <h5 v-if="false">客戶：{{ memberInfo.fullName }} {{ genderCheck }}</h5>
              <!-- 客戶資訊 -->
              <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
                <template v-slot:title>
                  <span>
                    <BaseIcon icon-style="fal" name="address-card" :class="[$style['header-icon-left'], 'fs-2xl', 'mr-3', 'align-text-bottom']" />
                    客戶資訊
                  </span>
                </template>
                <OrderMemberInfo :member-info="memberInfo" @toDetail="goToMemberInfoDetail" />
              </BaseCollapse>
              <!-- 左側的選擇寵物列表，上面是常態模式，下面是訂單變更模式 -->
              <LeftPetTab
                v-if="!isAutoOpen && drawerOpenType.normal && !isModified"
                :container-group-pet-id="containerGroupPetId"
                :show-add="true"
                :active-name="activeName"
                :service-count-by-pet="serviceCountByPet"
                @handleClickPetTab="handleClickPetTab"
                @updateActiveName="updateActiveName"
              />
              <LeftPetTab
                v-if="!isAutoOpen && drawerOpenType.normal && isModified"
                :container-group-pet-id="modifyPetInfo"
                :show-add="true"
                :active-name="activeName"
                :service-count-by-pet="modifyOrder"
                @handleClickPetTab="handleClickPetTab"
                @updateActiveName="updateActiveName"
              />
              <div v-if="!isAutoOpen && drawerOpenType.normal" :class="petSizeId ? `orderformSection__left__content__bg` : ''">
                <!-- 寵物資訊、使用人資訊 -->
                <template>
                  <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
                    <template v-slot:title>
                      <span>
                        <BaseIcon v-if="$merchantI18n() === 'pet'" name="bone" :class="[$style['header-icon-left'], 'fs-lg', 'mr-3']" style="transform: rotate(-45deg)" />
                        {{ $t('reserve.CLIENT') }}資訊
                      </span>
                    </template>
                    <OrderPetInfo
                      :default-value="submitData"
                      :member-info="memberInfo"
                      :pet-list="petList"
                      @toDetail="goToPetInfoDetail"
                      @onSelect="openSelectPet"
                      @seeRelatedQ="openRelatedQ"
                      @selectedPetInfo="selectedPetInfo"
                    />
                  </BaseCollapse>
                </template>
                <!-- 服務項目 -->
                <template v-if="petSizeId">
                  <BaseCollapse v-loading="modifiedLoading" expanded is-order :order-theme="true" arrow-style="far">
                    <template v-slot:title>
                      <span> <BaseIcon v-if="$merchantI18n() === 'pet'" name="cut" :class="[$style['header-icon-left'], 'fs-lg', 'mr-3']" /> 服務項目 </span>
                    </template>
                    <div class="currentServiceCont">
                      <div class="btn-group-inline" style="margin-bottom: 30px; padding-top: 0">
                        <el-button
                          class="is-round isInputGroup"
                          :class="{ isActive: serviceType === 'order', ishasCurrentServiceCont: submitData.params[0].priceId }"
                          @click="onSelectServiceType('order')"
                          >服務預約</el-button
                        >
                        <el-button
                          class="is-round isInputGroup"
                          :class="{ isActive: serviceType === 'prepaid-order', ishasCurrentServiceCont: submitData.params[0].priceId }"
                          @click="onSelectServiceType('prepaid-order')"
                          >{{ $t('prepaid.BASE') }}方案預約</el-button
                        >
                      </div>
                      <div v-if="submitData.params[0].priceId" class="currentServiceContItem">
                        <div class="inline-between mb-2">
                          此次選擇服務項目
                          <el-button type="text" style="padding-top: 0;" size="mini" @click="openRightSelectService"> <BaseIcon name="edit" class="text-primary mr-2" />重新選擇 </el-button>
                        </div>
                        <div class="text mb-2" v-for="(text, index) in currentServiceCont" :key="index + 1">
                          {{ text }}
                        </div>
                      </div>
                      <div v-for="(item, index) in petServiceGroupList" :key="index" :class="$style.serviceCollapse">
                        <div :class="$style.serviceCollapse__context">
                          <div class="inline-between mb-2">
                            {{ item.petName }} - 已預約服務項目
                            <el-button type="text" style="padding-top: 0;" size="mini" @click="deleteRightSelectService(item)"> <BaseIcon name="trash-alt" class="text-primary mr-2" />刪除 </el-button>
                          </div>
                          <div class="text">
                            {{ item.contTitle }}
                          </div>
                          <p>{{ item.date }} {{ item.time }}</p>
                          <div :class="$style.serviceCollapse__detail">
                            <div :class="$style.serviceCollapse__member">
                              <p
                                >服務人員：<span> {{ item.name }}</span></p
                              >
                              <template v-if="item.orderDetail.status !== 0" style="margin-bottom: 15px;">
                                <div v-if="item.orderDetail.status === 6" :class="$style.editOneLine" style="margin-top: 15px; padding: 0 20px">
                                  <h5 class="editOneLine__title">助理：</h5>
                                  <span class="editOneLine__text">{{ helperWords(item, 'helpers') }} </span>
                                </div>

                                <div v-else element-loading-background="rgba(0, 0, 0,0)" :class="$style.editOneLine" style="margin-top: 15px padding:0  20px">
                                  <!-- 助理title -->
                                  <h5 class="editOneLine__title">助理：</h5>
                                  <!-- 助理下拉選單 => submitData.helpers.length > 0 是因為要晚點渲染-->
                                  <HelperSelectOption item-show-key="editAssistantEnabled" :item="item" :submit-data.sync="forHelperSubmitData" submit-data-key="helpers" :assign-list="assignList" />
                                  <HelperForShow item-show-key="editAssistantEnabled" :item="item" show-key="helpers" />
                                  <!-- 助理的編輯icon -->
                                  <HelperIcon item-show-key="editAssistantEnabled" :item="item" :active-name="activeName" :index="index" emit-type="prices" @openAssignEdit="openAssignEdit" />
                                  <!-- 助理開啟編輯的儲存取消 -->
                                  <HelperSaveCancelBtn
                                    item-show-key="editAssistantEnabled"
                                    cancel-type="prices"
                                    :item="item"
                                    :index="index"
                                    :is-space="0"
                                    @cancelAssignEdit="cancelAssignEdit"
                                    @tryToStoreAssignHelper="tryToStoreAssignHelper"
                                  />
                                </div>
                              </template>

                              <template v-if="item.orderDetail.status !== 0 && $hasSpaceModule()">
                                <div v-if="item.orderDetail.status === 6" :class="$style.editOneLine" style="margin-top: 15px ;padding:0  20px">
                                  <h5 class="editOneLine__title">空間：</h5>
                                  <span class="editOneLine__text"> {{ helperWords(item, 'spaceHelpers') }} </span>
                                </div>

                                <div v-else element-loading-background="rgba(0, 0, 0,0)" :class="$style.editOneLine" style="margin-top: 15px; padding:0  20px">
                                  <!-- 空間title -->
                                  <h5 class="editOneLine__title">空間：</h5>
                                  <!-- 空間下拉選單 -->
                                  <HelperSelectOption item-show-key="editSpaceEnabled" :item="item" :submit-data.sync="forHelperSubmitData" submit-data-key="spaceHelpers" :assign-list="assignList" />
                                  <!-- 沒有下拉時候的顯示 -->
                                  <HelperForShow item-show-key="editSpaceEnabled" :item="item" show-key="spaceHelpers" />
                                  <!-- 空間的icon -->
                                  <HelperIcon item-show-key="editSpaceEnabled" :item="item" :active-name="activeName" :index="index" emit-type="space" @openAssignEdit="openAssignEdit" />
                                  <!-- 空間開啟編輯的儲存取消 -->
                                  <HelperSaveCancelBtn
                                    item-show-key="editSpaceEnabled"
                                    cancel-type="spaces"
                                    :item="item"
                                    :index="index"
                                    :is-space="1"
                                    @cancelAssignEdit="cancelAssignEdit"
                                    @tryToStoreAssignHelper="tryToStoreAssignHelper"
                                  />
                                </div>
                              </template>
                            </div>
                            <el-button v-if="defaultValue.status === 3" class="is-round ml-auto" type="primary" :disabled="tryingStore" :loading="tryingStore" @click="overTimeCalDialog">
                              待報到
                            </el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </BaseCollapse>
                </template>
              </div>
              <!-- 到府專用地址 -->
              <template v-if="isHomeService">
                <BaseCollapse expanded is-order :order-theme="true">
                  <template v-slot:title>
                    <span> <BaseIcon name="map-marker-alt" /> 服務地址 </span>
                  </template>
                  <div style="margin-bottom:30px">
                    <div v-if="submitData.city" style="margin-bottom:20px">服務地址：{{ submitData.city }}{{ submitData.district }}{{ submitData.address }}</div>
                    <el-button v-if="!defaultValue.city" type="text" style="padding-top: 0; text-decoration: underline" @click="openAddressEdit"> 新增服務地址 </el-button>
                    <el-button v-else type="text" style="padding-top: 0; text-decoration: underline" @click="openAddressEdit"> 編輯服務地址 </el-button>
                  </div>
                </BaseCollapse>
              </template>
            </template>
          </div>
          <template v-if="!visibleMemberSearch && isAutoOpen && (drawerOpenType.autoOpenForGoodsAndVisit || drawerOpenType.autoOpenForGoodsAndMember) && showGoodsList">
            <!-- 這裡是商品的totalStatement -->
            <TotalStatement
              enabled-edit
              order-type="goods"
              :default-value="submitData"
              :default-coupon="couponInfo"
              :container-edit="containerEdit"
              :buying-prepaid-info="submitDataPrepaid"
              :member-info="memberInfo"
              @openAdd="openAddEdit"
              @update="onUpdateTotalStatement"
              @updateParam="updateSubmitDataParams"
              @deleteOffTime="$emit('clearOffLineParams')"
              @handleRemoveGoods="handleRemoveGoods"
            >
            </TotalStatement>
            <div style="padding: 20px 30px 0;">
              <el-button class="is-round" style="width: 100%;" @click="openPriceEditAndDiscount">
                價格編輯與折扣
              </el-button>
            </div>
          </template>
        </div>
      </div>
      <!-- 原本抽屜的右半部分 -->
      <div v-if="!completeReserveAndPayStatus" class="orderformSection__right">
        <el-select
          v-if="computedForLocationSelect"
          slot="label"
          v-model="locationValue"
          :class="[$style.productPlacement]"
          class="is-no-tb-border is-r-border"
          placeholder="請選擇服務地點"
          style="color: white;"
          @change="changeLocation"
        >
          <el-option v-for="(location, typeValue) in merchantProducts" :key="typeValue" :label="location.name" :value="location.id"></el-option>
        </el-select>
        <template>
          <!-- 客戶編輯 -->
          <template v-if="visibleMemberDetailEdit">
            <MemberForm
              :is-auto-open="isAutoOpen"
              :drawer-open-type="drawerOpenType"
              :default-value="memberInfo"
              :add-member-status="addMemberStatus"
              @update="tryToFetchDetail"
              @close="closeEditMemberForm"
              @releaseMemberPhoneDisable="releaseMemberPhoneDisable"
              @showMemberInfo="showMemberInfo"
            />
          </template>
          <!-- 客戶資訊 -->
          <template v-if="memberInfoShow && !visibleMemberDetailEdit">
            <MemberInfo :member-info="memberInfo" :member-info-active-tab="memberInfoActiveTab" @update="tryToFetchDetail" @close="closeMemberInfo" />
          </template>
          <!-- 寵物選擇 -->
          <template v-if="petShow">
            <PetList
              :active-id="submitData.petId"
              :member-info="memberInfo"
              :pet-info-active-tab="petInfoActiveTab"
              :is-show-pet-list="isShowPetList"
              :alias="currentStoreAlias"
              @close="closePet"
              @selected="selectPet"
              @update="tryToFetchDetail(memberInfo.id)"
            />
          </template>
          <!-- 服務選擇 -->
          <template v-if="serviceShow">
            <ServiceList
              :set-services-member-level-price="setServicesMemberLevelPrice"
              :pet-id="submitData.petId"
              :member-info="memberInfo"
              :products="isModified ? modifyProduct : products"
              :active-id="currentService && currentService.id"
              @close="closeService"
              @selected="selectService"
            />
          </template>
          <!-- 編輯到府地址 -->
          <template v-if="addressShow">
            <AddressForm :default-value="submitData" :products="products" :loading="tryingStore" @update="saveHomeAddress" @close="closeAddress" />
          </template>
        </template>
        <!-- 變價 -->
        <template v-if="!isAutoOpen && drawerOpenType.normal">
          <div :class="[$style.total]">
            <div class="total__cont">
              <TotalStatement
                enabled-edit
                order-type="reservation"
                :default-value="submitData"
                :default-coupon="couponInfo"
                :container-edit="containerEdit"
                :buying-prepaid-info="submitDataPrepaid"
                :member-info="memberInfo"
                @openAdd="openAddEdit"
                @update="onUpdateTotalStatement"
                @updateParam="updateSubmitDataParams"
                @deleteOffTime="$emit('clearOffLineParams')"
              >
                <div v-if="submitData.params[0].priceId" class="btn-group-inline" :class="$style.bottom" style="padding: 0  0 30px 0px; background-color: $color-line;">
                  <el-button class="is-round" @click="openAddDrawer">加購</el-button>
                  <el-button plain class="is-round" @click="openTotalEdit">價格編輯與折扣</el-button>
                </div>
              </TotalStatement>
            </div>
          </div>
        </template>
        <template v-if="isAutoOpen && (drawerOpenType.autoOpenForGoodsAndNonMember || drawerOpenType.autoOpenForGoodsAndMember || drawerOpenType.autoOpenForGoodsAndVisit)">
          <div :class="{ [$style.total]: true, [$style.categoryList]: isAutoOpen && drawerOpenType.autoOpenForGoodsAndNonMember, [$style.goodsListHeader]: false }">
            <div class="total__cont">
              <GoodsList
                v-if="!visibleMemberDetailEdit && (drawerOpenType.autoOpenForGoodsAndVisit || drawerOpenType.autoOpenForGoodsAndMember) && showGoodsList"
                :location-value="locationValue"
                @backToItemHome="backToItemHome"
                @addSelectedGoods="addSelectedGoods"
              />
              <CategoryToLink v-if="!visibleMemberDetailEdit && !drawerOpenType.autoOpenForGoodsAndVisit && !showGoodsList" @emitToLink="emitToLink" />
            </div>
          </div>
        </template>
      </div>

      <!-- 點選完成預約，立即付款後的視窗 -->
      <div v-if="completeReserveAndPayStatus" class="orderformSection__info">
        <div class="orderformSection__info__header">
          <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click.stop="completeReserveAndPayStatus = false"><i class="el-dialog__close el-icon el-icon-close"></i></button>
          <h4 class="orderformSection__info__title">
            <div class="inline-between" style="padding-right: 15px; align-items: center">
              <span> 預約資訊 </span>
            </div>
          </h4>
        </div>
        <div class="orderformSection__info__content">
          <ReservePersonInfo ref="reserveForm" :member-info="memberInfo" @updatePayPersonInfo="updatePayPersonInfo" />
        </div>
      </div>

      <!-- 底部按鈕 -->
      <div class="orderformSection__bottom">
        <div v-if="isAutoOpen && !showGoodsList && (drawerOpenType.autoOpenForGoodsAndNonMember || drawerOpenType.autoOpenForGoodsAndMember)" class="orderformSection__bottom__autoOpenNonMember">
          <p class="orderformSection__bottom__autoOpenNonMember__title">查詢客戶-選擇項目</p>
          <p class="orderformSection__bottom__autoOpenNonMember__text">點選右側項目後，即可進行下一步</p>
        </div>
        <div v-if="isAutoOpen && showGoodsList && (drawerOpenType.autoOpenForGoodsAndMember || drawerOpenType.autoOpenForGoodsAndVisit)" class="orderformSection__bottom__autoOpenNonMember">
          <p class="orderformSection__bottom__autoOpenNonMember__title">商品購買中</p>
          <p class="orderformSection__bottom__autoOpenNonMember__text">點選右側項目後，即可進行下一步</p>
        </div>
        <div v-if="!isAutoOpen" style="display: flex; align-items: center">
          <BaseStateLabel :state="defaultValue.paymentStatus | paymentStatusMapFilter('color')" class="is-border">
            {{ defaultValue.paymentStatus | paymentStatusMapFilter('text') }}
          </BaseStateLabel>
          <div style="padding-left: 20px" class="text-secondary fw-medium Jost">
            應付 NT$ <span v-if="isBuyPrepaid"> {{ formatMemberLevelPrepaidPrice() }} + </span> {{ submitPriceTotal }}
            <div v-if="!submitData.params[0].priceId" class="text-muted-0" style="padding-top: 5px">未選擇付款方式</div>
          </div>
        </div>
        <div v-if="!isAutoOpen" class="orderformSection__bottom__right">
          <el-button
            v-if="false"
            class="is-round orderformSection__bottom__btn"
            type="primary"
            :disabled="tryingStore || !submitData.params[0].priceId"
            :loading="tryingStore"
            @click="handleStoreOrder"
            >{{ isBuyPrepaid ? `購買${$t('prepaid.BASE')} 方案 + 新增預約` : '新增預約' }}</el-button
          >

          <el-button
            v-if="(haveNewOrder || haveOldOrder) && !completeReserveAndPayStatus && !isModified && !serviceShow"
            class="is-round orderformSection__bottom__payImmediate"
            :loading="storeSingleOrderStatus"
            @click="completeReserveAndPay"
            >前往付款</el-button
          >
          <el-button v-if="serviceShow" class="is-round orderformSection__bottom__serviceBtn" type="primary" @click="completeReserveFunc">確認服務，下一步</el-button>

          <el-button v-if="completeReserve && !isModified" class="is-round orderformSection__bottom__completeBtn" type="primary" :loading="storeSingleOrderStatus" @click="quicklyDialogVisible = true"
            >省略付款</el-button
          >

          <el-button
            v-if="completeReserve && !isModified"
            class="is-round orderformSection__bottom__completeBtn"
            type="primary"
            :loading="storeSingleOrderStatus"
            @click="storeSingleOrderAndCloseDrawer"
            >繼續預約</el-button
          >
          <el-button
            v-if="!serviceShow && isModified"
            class="is-round orderformSection__bottom__completeBtn"
            type="primary"
            :loading="storeSingleOrderStatus"
            :disabled="!modifyOrderIsChange"
            @click="storeSingleOrderAndCloseDrawer"
            >確認變更</el-button
          >
          <el-button v-if="completeReserveAndPayStatus" class="is-round orderformSection__bottom__completeBtn" @click="completeReserveAndPayStatus = false">取消填寫，返回</el-button>
          <el-button v-if="completeReserveAndPayStatus" class="is-round orderformSection__bottom__completeBtn" type="primary" @click="checkResultAndPay">確認填寫，{{ directPayText }}</el-button>
        </div>
      </div>

      <!-- 快速成立訂單彈窗 -->
      <el-dialog title="確認建立訂單" :visible.sync="quicklyDialogVisible" top="0" width="40%" :append-to-body="true" :close-on-click-modal="!storeSingleOrderStatus" :show-close="false">
        <span slot="footer" class="dialog-footer">
          <el-button class="is-round w-25" :loading="storeSingleOrderStatus" @click="quicklyDialogVisible = false">否</el-button>
          <el-button type="primary" class="is-round w-25" :loading="storeSingleOrderStatus" @click="createOrderQuickly('UNPAID')">是</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 變價或加購 -->
    <div v-if="totalAllShow" class="orderformSection__all">
      <div class="orderformSection__right" style="border-right: #dcdfe6 1px solid">
        <div class="orderformSection__right__header">
          <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click.stop="closeTotalAll"><i class="el-dialog__close el-icon el-icon-close"></i></button>
          <h4 class="orderformSection__right__title">
            <div class="inline-between" style="padding-right: 15px; align-items: center">
              <span> 價格編輯與折扣 </span>
            </div>
          </h4>
        </div>
        <!-- 右邊加購項目 -->
        <div class="orderformSection__right__content" style="padding: 0 0 20px 0">
          <div v-if="selectSingleOrder" :class="'orderformSection__beforeTotalAllShowLeft__box'">
            <div
              v-if="Object.keys(containerOrders).length > 0 && !flagAddDrawer && false"
              :class="['orderformSection__beforeTotalAllShowLeft__info', 'orderformSection__beforeTotalAllShowLeft__moreMargin']"
            >
              <el-button class="is-round" type="primary" @click="selectOrderAndAddition({}, 'all')">為總訂單新增加購</el-button>
            </div>
            <div :class="['orderformSection__beforeTotalAllShowLeft__info', 'orderformSection__beforeTotalAllShowLeft__moreMargin']">
              <el-button class="is-round" type="primary" @click="selectOrderAndAddition({}, 'newOrder')">價格編輯與折扣</el-button>
            </div>
            <div v-for="(item, index) in containerParentIdNullOrder" :key="index">
              <p>{{ item.date }} {{ item.time }}</p>
              <div :class="'orderformSection__beforeTotalAllShowLeft__info'">
                <div>
                  <p>{{ item.pet.name }}</p
                  ><span>{{ item.pet.categoryTitle }}/{{ item.pet.sizeTitle }}</span>
                </div>
                <div>
                  <p>{{ item.params[0].title }}</p>
                </div>
                <el-button class="is-round" type="primary" @click="selectOrderAndAddition(item, 'oldOrder')">新增加購</el-button>
              </div>
            </div>
          </div>
          <TotalStatement
            v-else
            enabled-edit
            enabled-addition
            order-type="reservation"
            :default-value="submitData"
            :default-coupon="couponInfo"
            :container-edit="containerEdit"
            :buying-prepaid-info="submitDataPrepaid"
            :member-info="memberInfo"
            @openAdd="openAddEdit"
            @openTotalEdit="openTotalEdit"
            @update="onUpdateTotalStatement"
            @updateParam="updateSubmitDataParams"
            @deleteOffTime="$emit('clearOffLineParams')"
          >
            <div :class="$style.bottom" style="padding: 0 0 26px;">
              <el-form v-if="(serviceTotal > 0 || serviceTotal.length) && !submitData.prepaidOrderUuid && !isBuyPrepaid" ref="couponForm" :model="submitData" :rules="submitRules">
                <el-form-item ref="couponCode" class="el-form-item--white-bg" prop="couponCode">
                  <el-input v-model="submitData.couponCode" clearable :disabled="!!hasCouponInfo" placeholder="請輸入優惠券代碼" class="isStyleButton">
                    <el-button v-if="hasCouponInfo" slot="append" class="is-round is-border" @click="resetCoupon">清除優惠券 </el-button>
                    <el-button v-else slot="append" type="primary" class="is-round" @click="validCoupon">使用優惠券 </el-button>
                  </el-input>
                </el-form-item>
              </el-form>
              <div class="btn-group-inline">
                <el-button class="is-round" type="primary" @click="saveTotalEdit">儲存</el-button>
              </div>
            </div>
          </TotalStatement>
        </div>
      </div>
      <!-- 點選加購之後，先跳出要選哪個訂單 -->
      <div v-if="selectSingleOrder" class="orderformSection__mask">
        <div>
          <p>尚未選擇需要加購的預約</p>
        </div>
        <div> </div>
      </div>
      <!-- 選完哪個訂單之後，開始加購 -->
      <div class="orderformSection__left" style="border: 0">
        <div class="orderformSection__left__content" style="padding-bottom: 0">
          <!-- 加購 -->
          <template v-if="visibleAdditionForm">
            <div class="orderformSection__right__header">
              <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click.stop="closeAdd"><i class="el-dialog__close el-icon el-icon-close"></i></button>
              <h4 class="orderformSection__right__title">
                <div class="inline-between" style="padding-right: 15px; align-items: center"> 加購 </div>
              </h4>
            </div>
            <!-- 右邊加購列表 -->
            <div class="info-section">
              <AdditionFormOrder
                ref="addForm"
                :pet-size-id="petSizeId"
                :pet-category-id="petCategoryId"
                :member-info="memberInfo"
                :this-time-selected-pet-info="thisTimeSelectedPetInfo"
                :default-value="submitData"
                :set-services-member-level-price="setServicesMemberLevelPrice"
                :schedule-detail="scheduleDetail"
                :schedules="schedules"
                :current-service="currentService"
                :is-modified="isModified"
                :modify-order="modifyOrder"
                @submit="onSubmitAddition"
                @close="closeAdd"
              />
            </div>
          </template>
          <!-- 變價 -->
          <TotalEdit v-else @submit="onSubmitTotalEdit"></TotalEdit>
        </div>
      </div>
    </div>

    <!-- 簽名請款 -->
    <SignatureDialog
      :one-step="true"
      :start-tab="1"
      :member-info="memberInfo"
      :props-store-invoice-setting="storeInvoiceSetting"
      :visible.sync="signDialogVisible"
      :order="{ ...defaultValue }"
      @closeSignature="signDialogVisible = false"
      @closeSignaturDialog="closeSignaturDialog"
    />

    <!-- 付款方式列表 -->
    <div v-if="checkResultAndPayStatus" :class="$style.payListF">
      <PayList
        :props-loading="propsLoading"
        :pay-person-info="payPersonInfo"
        :submit-price-total="submitPriceTotal"
        :have-new-order="haveNewOrder"
        :member-info="memberInfo"
        :order-container-uuid="orderContainerUuid"
        :child-order-container-id="testUnpaidContainer"
        :container-orders="containerOrders"
        :store-invoice-setting="storeInvoiceSetting"
        :new-order-info="currentService"
        @showSignDialogFromPayList="showSignDialogFromPayList"
        @close="$emit('store')"
        @paymentMethodDeposit="paymentMethodDeposit"
        @goBack="backToInfo"
        @checkOutSuccess="checkOutSuccess"
        @storeSingleOrder="storeSingleOrder"
      />
    </div>

    <!-- 選擇包套抵扣或購買包套方案 -->
    <PrepaidList
      v-if="prepaidAllShow && !completeReserveAndPayStatus && !isModified"
      :pet-id="submitData.petId"
      :member-info="memberInfo"
      :products="products"
      :schedule-detail="scheduleDetail"
      @use="onSelectedPrepaid"
      @buy="onSelectedBuyingPrepaid"
      @updateMemberInfo="tryToFetchMemberInfo"
      @close="closePrepaidAll"
    />
    <PrepaidList
      v-if="prepaidAllShow && !completeReserveAndPayStatus && isModified"
      :pet-id="submitData.petId"
      :member-info="memberInfo"
      :products="modifyProduct"
      :schedule-detail="scheduleDetail"
      :is-modified="isModified"
      :modify-order="modifyOrder"
      @use="onSelectedPrepaid"
      @buy="onSelectedBuyingPrepaid"
      @updateMemberInfo="tryToFetchMemberInfo"
      @close="closePrepaidAll"
    />

    <!-- 選擇付款方式和訂單狀態 -->
    <PaymentFormDialog :visible.sync="paymentDialogVisible" :payment-way="paymentWay" :loading="tryingStore" @submit="onSubmitPaymentForm" />

    <!-- 付款備註 -->
    <el-dialog :visible.sync="extraDialogVisible" width="550px" top="0" title="備註" :close-on-click-modal="false" append-to-body @closed="closeExtraDialogVisible">
      <el-form ref="extraForm" :model="currentOrder" :rules="submitRules" label-position="top" class="el-form-item--normal-margin">
        <div style="display: flex; margin-bottom: 10px">
          <h6 style="margin-top: 0">使用人</h6>
          <el-checkbox v-model="userSameAsMember" class="check-by-head">使用人同客戶</el-checkbox>
        </div>
        <el-row :gutter="20">
          <el-col :span="15">
            <el-form-item prop="fullName" class="el-form-item--white-bg-border" label="姓名">
              <el-input v-model="currentOrder.fullName" :disabled="userSameAsMember" placeholder="姓名"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item class="gender-box" prop="gender">
              <el-radio-group v-model="currentOrder.gender" class="no-bg-radio-group">
                <el-radio label="male">先生</el-radio>
                <el-radio label="female">小姐</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="phoneNumber" class="el-form-item--white-bg-border" label="電話">
              <el-input v-model="currentOrder.phoneNumber" :disabled="userSameAsMember" placeholder="手機號碼" autocomplete="tel">
                <CountryCodePicker slot="prepend" v-model="currentOrder.phoneCode" :disabled="userSameAsMember" />
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form class="el-form-item--normal-margin el-form--label-top">
        <OrderExtraField :default-value="currentOrder" />
        <el-form-item label="使用人備註">
          <small style="display: block; opacity: 0.5; line-height: 1.3; margin-bottom: 10px">客戶可瀏覽此備註。若是不需要提供客戶瀏覽的資訊，請使用「內部備註」功能</small>
          <el-input v-model="currentOrder.note" type="textarea" :rows="3" class="bg-white is-border is-round"> </el-input>
        </el-form-item>
      </el-form>
      <el-button class="is-round is-fullwidth" type="primary" :loading="tryingStore" :disabled="tryingStore" @click="tryToSaveOrder"> 儲存並完成 </el-button>
    </el-dialog>

    <!-- 開啟相關問答跳窗 -->
    <el-dialog :visible.sync="relatedQuestionPopWindow" width="550px" top="0" title="相關問答" :before-close="handleBeforeQClose" :close-on-click-modal="false" append-to-body>
      <el-form class="el-form-item--normal-margin el-form--label-top">
        <OrderExtraField :default-value="currentOrder" />
      </el-form>
      <div>
        <el-button class="is-round is-fullwidth" @click="qBtn(true)">略過問答</el-button>
        <el-button class="is-round is-fullwidth" type="primary" @click="qBtn(false)">儲存問答</el-button>
      </div>
    </el-dialog>

    <!-- 新增儲值金訂單 -->
    <el-drawer
      ref="depositOrderForm"
      class="only-close"
      :class="{ appStyle: appStyle }"
      :visible.sync="createDepositOrderVisible"
      :append-to-body="true"
      :size="$root.isSmallDevice ? '100%' : '90%'"
      destroy-on-close
      :modal-append-to-body="false"
      :wrapper-closable="false"
      custom-class="order-drawer"
    >
      <DepositOrderForm :order-member-id="memberInfo.id" order-type="deposit" @store="onCreateDepositOrderDone" />
    </el-drawer>

    <!-- 非營業時段結束安親確認視窗 -->
    <OffLineReserveWindow type="overTime" :over-time-reserve-window-status="overTimeReserveWindowStatus" @closeOffLineWindow="offTimeReserveResolveFunc" @previousFun="previousFun" />
  </div>
</template>

<script>
import lazyLoadComponent from '@router/lazyload-component'
import { mapGetters, mapState } from 'vuex'
import { genderFilter, findDistrictZip, paymentStatusMapFilter } from '@utils/filter-value-to-text'
import formatDate, { formatGetTime } from '@utils/format-date'
import { formatStatusMessage } from '@utils/request'
import { calcTotal, calcBasePrice } from '@utils/order-form'
import cloneDeep from 'lodash/cloneDeep'
import { saveState, getSavedState } from '@utils/browser-help'
import reserveOrder from '@src/mixins/reserveOrder'
import memberLevelDiscountMixin from '@src/mixins/memberLevelDiscountMixin'
import moment from 'moment'
import helperMixin from '@src/mixins/helperMixin'
import orderFormMixin from '@/src/mixins/orderFormMixin'
import overTimeMixin from '@/src/mixins/overTimeMixin'
import productMixin from '@/src/mixins/product'
import store from '@/src/state/store'

const paramsItem = () => {
  return {
    type: 'cosmetic',
    title: '',
    priceId: '',
    price: 0,
    qty: 0,
  }
}

const initData = () => {
  return {
    params: [paramsItem()],
    fullName: '',
    gender: 'male',
    phoneCode: '+886',
    phoneNumber: '',
    phone: '',
    // bankType:'',
    email: '',
    note: '',
    status: 2,
    paymentStatus: 'UNPAID',
    basePrice: '',
    total: '',
    allowExpired: 0,
    couponCode: '',
    memberId: '',
    prepaidOrderUuid: '',
    byOrderExtrafields: {},
    customerInfos: [],
    // paymentMethod: 'Prepaid',
    paymentMethod: '',
    productId: '',
    bankType: '',
    address: '',
    petId: '',
    city: '',
    district: '',
    errorHandle: false,
    type: '',

    // 假資料先暫做
    storeCredit: '',
    credit: '',
  }
}

export default {
  components: {
    BaseCollapse: () => lazyLoadComponent(import('@components/BaseCollapse')),
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    OrderExtraField: () => lazyLoadComponent(import('@components/OrderExtraField')),
    DepositOrderForm: () => lazyLoadComponent(import('./DepositOrderForm')),
    OffLineReserveWindow: () => lazyLoadComponent(import('./offLineReserveWindow')),
    CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
    SignatureDialog: () => lazyLoadComponent(import('@components/SignatureDialog')),

    /* 重構元件 */
    TotalEdit: () => lazyLoadComponent(import('./components/TotalEdit')),
    AdditionFormOrder: () => lazyLoadComponent(import('./components/AdditionFormOrder')),
    PrepaidList: () => lazyLoadComponent(import('./components/PrepaidList')),
    PetList: () => lazyLoadComponent(import('./components/PetList')),
    MemberForm: () => lazyLoadComponent(import('./components/MemberForm')),
    MemberInfo: () => lazyLoadComponent(import('./components/MemberInfo')),
    ServiceList: () => lazyLoadComponent(import('./components/ServiceList')),
    AddressForm: () => lazyLoadComponent(import('./components/AddressForm')),
    MemberSearchForm: () => lazyLoadComponent(import('./components/MemberSearchForm')),
    PaymentFormDialog: () => lazyLoadComponent(import('./components/PaymentFormDialog')),
    TotalStatement: () => lazyLoadComponent(import('./components/TotalStatement')),
    OrderMemberInfo: () => lazyLoadComponent(import('./components/OrderMemberInfo')),
    OrderPetInfo: () => lazyLoadComponent(import('./components/OrderPetInfo')),
    ReservePersonInfo: () => lazyLoadComponent(import('./components/ReservePersonInfo')),
    PayList: () => lazyLoadComponent(import('./components/PayList')),
    LeftPetTab: () => lazyLoadComponent(import('./components/LeftPetTab')),
    HelperForShow: () => lazyLoadComponent(import('./components/HelperForShow')),
    HelperIcon: () => lazyLoadComponent(import('./components/HelperIcon')),
    HelperSaveCancelBtn: () => lazyLoadComponent(import('./components/HelperSaveCancelBtn')),
    HelperSelectOption: () => lazyLoadComponent(import('./components/HelperSelectOption')),
    CategoryToLink: () => lazyLoadComponent(import('./components/CategoryToLink')),
    GoodsList: () => lazyLoadComponent(import('./components/GoodsList')),
  },
  filters: {
    formatDate,
    paymentStatusMapFilter,
    genderFilter,
  },
  mixins: [reserveOrder, memberLevelDiscountMixin, orderFormMixin, helperMixin, orderFormMixin, overTimeMixin, productMixin],
  props: {
    // 是否開啟發票輸入畫面 -> 1 開啟 / 0 關閉
    storeInvoiceSetting: {
      type: Number,
      default: -1,
    },
    serviceTimeSetting: {
      type: Object,
      default: () => {},
    },
    offLineParams: {
      type: Object,
      default: () => {},
    },
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
    products: {
      type: Array,
      default: () => [],
    },
    scheduleDetail: {
      type: Object,
      default: () => {},
    },
    schedules: {
      type: Array,
      default: () => [],
    },
    orderType: {
      type: String,
      validator: (val) => {
        return ['reservation', 'prepaid', 'deposit'].includes(val)
      },
      required: true,
    },
    /**
     * @description 點擊商店的相關問答（陣列模式
     */
    beforeApiExtraFields: {
      type: Array,
      default: () => [],
    },
    isAutoOpen: {
      type: Boolean,
      default: false,
    },
    /**
     * @description 這個商店的分店列表
     */
    merchantProducts: {
      type: Array,
      default: () => {
        return []
      },
    },
    goodsOrderId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      orderHeaderId: `orderHeader__${Math.floor(Math.random() * 10000)}`,
      type: 'order',
      headerHeight: 0,
      submitData: Object.assign({}, this.defaultValue),
      currentOrder: {},
      currentOrderId: '',
      submitDataPrepaid: {
        prepaidId: '',
        status: 2,
        paymentMethod: 'Cash',
        bankType: '',
        taxType: 'B2C',
        CarrierType: '',
        CarrierNum: '',
        taxId: '',
        LoveCode: '',
        invoiceSync: true,
        basePrice: 0,
        total: 0,
        params: [],
      },
      couponInfo: {},
      previousCouponCode: '',

      // 全畫面
      prepaidAllShow: false,
      totalAllShow: false, // 真正讓使用者看到加購視窗
      selectSingleOrder: false, // 在進入加購視窗前，先選擇單筆訂單

      // 左邊的 show
      visibleMemberSearch: true,
      showGoodsList: false, // 確認商品購買點下去
      // 右邊的show，左邊有任何選擇，右邊的show要全部關掉
      memberInfoShow: false,
      petShow: false,
      visibleMemberDetailEdit: false,
      serviceShow: false,
      visibleAdditionForm: false,
      addressShow: false,

      // totalShow:true,

      // dialog show
      paymentDialogVisible: false,
      extraDialogVisible: false,

      // 各種 loading
      tryingStore: false,
      tryingGetMember: false,
      modifiedLoading: false,
      serviceType: '',
      paymentWay: 'offline',
      // paymentTitle:'到店付款(現金)'
      userSameAsMember: true,

      isPrepaidAndTotalEdit: false,
      /* additionList: [],
      totalEditList: [], */
      basePrice: 0, // 預約項目+加購項目+加價

      // 到府地址
      enableSaveAddress: false,

      createDepositOrderVisible: false,

      // 會員資訊
      memberInfo: {},
      memberInfoActiveTab: 'information',

      // 所選服務、所選包月、要購買的包月
      currentService: null,
      currentServiceCont: [],

      // 變價或加購
      // adds: [],

      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',

      // 寵物資訊
      petInfoActiveTab: 'information',
      // 是否顯示寵物列表
      isShowPetList: true,
      petList: [],
      overTimeReserveWindowStatus: false, // 非營業時段結束安親確認
      completeResAndPayBtn: false, // 完成預約立即付款btn出現
      completeReserveAndPayStatus: false, // 完成預約立即付款的視窗出去
      checkResultAndPayStatus: false, // 到結帳畫面（包含線下、線上、儲值得第一個畫面）
      thisTimeSelectedPetInfo: {}, // 這次選到的寵物資訊
      storeSingleOrderStatus: false, // 新增一筆預約的status（因為要擋掉正常儲存流程的跳窗
      activeName: '', // 寵物列表的tab control
      petServiceGroupList: [], // 將寵物group起來的服務列表
      thisTimeModiOrderId: '', // 因為有可能加購不同訂單，所以要先存起來這次想加購哪個訂單
      tempOriginalParams: [], // 因為使用者有可能點不同訂單，所以原本新增的要先存起來
      tempOriginalId: '', // 因為使用者有可能點不同訂單，所以原本新增的id要先存起來
      tempUpdateParams: {}, // 即時更新使用者的加價購
      payPersonInfo: {}, // 付款人資訊
      orderContainerUuid: '', // 單筆儲存回來的containnerId
      relatedQuestionPopWindow: false, // 相關問答跳窗
      stopCloseDrawer: () => {}, // 控制相關問答關窗流程(resolve)
      relatedCloseReject: () => {}, // 控制相關問答關窗流程
      containerOrders: {}, // container的訂單們
      containerEdit: false,
      flagAddDrawer: false, // 加購抽屜開啟
      overTimeParams: {}, // 超時之後的params
      signResolveFunc: () => {}, // 發票儲存後要讓PayList繼續做
      signRejectFunc: () => {}, // 發票儲存的上一步，要讓PayList Stop
      signDialogVisible: false,
      newOrderId: 0, // 這次新訂單的id,
      newOrderInfo: {
        canPayByDeposit: true,
      }, // 新選到服務內的資訊
      forHelperSubmitData: {}, // 助理的submitData（因為是修改其他單，所以另外做個submitData）
      forHelperDefaultData: {}, // 助理的defaultData
      assignList: [], // 助理下拉選單
      tryingAssign: false, // 找助理
      tryingAssignList: false, // 找助理清單
      staffSpecify: 'notSpecify', // 是否被指定（radio）
      isUseStaffPriceAdj: false, // 指定、不指定的disabled狀態
      propsLoading: false, // 讓子組件停止往下跑
      addMemberStatus: false, // 新增會員狀態
      drawerOpenType: {
        autoOpenForGoodsAndMember: false, // 有會員&&自動開啟
        autoOpenForGoodsAndNonMember: false, // 無會員無訪客&&自動開啟 => search 畫面
        autoOpenForGoodsAndVisit: false, // 訪客&&自動開啟
        normal: true, // 常態模式（一般drawer，使用者點的drawer）
      },
      locationValue: '', // 選擇的地點
      goodsOrderData: {},
      serviceTab: [
        {
          title: '預約服務',
          value: 'reservation',
        },
        {
          title: '商品購買',
          value: 'goods',
        },
      ],
      modifyProduct: [],
      quicklyDialogVisible: false,
      originalOrder: {},
    }
  },
  computed: {
    ...mapState('modifyOrder', ['modifyMemberInfo', 'modifyOrder']),
    ...mapGetters('modifyOrder', ['isModified', 'modifyPetInfo', 'modifyData']),
    /**
     * @description 沒有自動開啟與自動開啟的高度
     */
    notAutoOpenLeftContentHeight() {
      if (this.isAutoOpen) {
        return ''
      }
      return `height:calc(100vh - ${this.headerHeight}px)`
    },
    /**
     * @description 項目上面的選擇地點（條件：自動開窗＋一開始畫面才會有）
     */
    computedForLocationSelect() {
      // 自動開窗＋沒有會員＋訪客為false才開啟
      return (
        this.isAutoOpen &&
        this.drawerOpenType.autoOpenForGoodsAndNonMember &&
        !this.drawerOpenType.autoOpenForGoodsAndVisit &&
        !this.drawerOpenType.autoOpenForGoodsAndMember &&
        !this.visibleMemberDetailEdit
      )
    },
    /**
     * @description 商家是否有額外的相關問題
     */
    productHasExtraField() {
      if (this.beforeApiExtraFields && this.beforeApiExtraFields.length > 0) {
        return true
      }
      return false
    },
    /**
     * @description 這個畫面有新訂單(因為是在form裏面，有id就代表使用者有選到新的服務)
     */
    haveNewOrder() {
      if (this.submitData.params[0].priceId > 0) {
        return this.submitData.params[0].priceId
      } else {
        return 0
      }
    },
    /**
     * @description 這個畫面已經有舊訂單
     */
    haveOldOrder() {
      return this.containerGroupPetId.length > 0
    },
    /**
     * @description 現在是否已經有選到服務，已有選到服務才可以點完成預約btn
     */
    currentServiceContComputed() {
      const { qty, title } = this.submitData.params[0]
      if (this.currentServiceCont.length === 0 || (qty === 0 || title.length === 0)) {
        return true
      } else {
        return false
      }
    },
    /**
     * @description 「完成預約，立即付款」的btn，是否出現
     */
    completeReserve() {
      if (this.currentServiceCont.length > 0 && this.submitData.params[0].priceId && !this.serviceShow && !this.petShow && !this.completeReserveAndPayStatus) {
        return true
      } else {
        return false
      }
    },
    /**
     * @description 購買包月
     */
    isBuyPrepaid() {
      return !!this.submitDataPrepaid.prepaidId
    },
    /**
     * @description 使用已購買的包套抵扣
     */
    isPrepaidDeduct() {
      return this.serviceType === 'prepaid-order' && !this.isBuyPrepaid && !this.isPrepaidAndTotalEdit
    },
    filteredAvailablePrepaidList() {
      let available = []
      if (this.memberInfo.availablePrepaidOrders) {
        available = this.memberInfo.availablePrepaidOrders.filter((prepaid) => {
          return this.products.some((product) => {
            return prepaid.prices.some((price) => {
              const priceIds = product.prices.map((item) => item.id)
              const priceSizeIds = product.prices.map((item) => item.sizeId)
              const hasPrepaidSizeId = prepaid.sizeIds.includes(this.petSizeId)
              const hasScheduleSizeId = priceSizeIds.includes(this.petSizeId)
              const hasBoth = hasPrepaidSizeId && hasScheduleSizeId
              return priceIds.includes(price.id) && hasBoth
            })
          })
        })
      }

      return available
    },
    prepaidListAfterService() {
      const id = this.submitData.params[0].priceId
      return this.filteredAvailablePrepaidList.filter((item) => {
        return item.prices.some((i) => {
          return id === i.id
        })
      })
    },
    depositReduce() {
      const { bonus, point } = this.memberInfo.depositInfo.solution2.reduceDepositTotal
      return bonus + point
    },
    isHomeService() {
      return this.products.some((product) => product.id === this.submitData.productId && product.storeType === 'home')
    },
    filterCities() {
      if (!this.submitData.productId) {
        return []
      }
      const cities = this.products.find((item) => {
        return item.id === this.submitData.productId
      }).addressRestrictions
      return cities
    },
    petSizeId() {
      if (Object.keys(this.memberInfo).length > 0) {
        this.findPetServiceGroup()
      }
      const id = this.submitData.petId || this.submitData?.pet?.id
      if (id && this.petList.length) {
        return this.petList.find((item) => {
          return item.id === id
        }).sizeId
      } else {
        return 0
      }
    },
    petCategoryId() {
      if (this.submitData.petId) {
        return this.petList.find((item) => {
          return this.submitData.petId === item.id
        }).categoryId
      } else {
        return 0
      }
    },
    submitRules() {
      const isTaiwan = this.submitData.phoneCode === '+886'
      let validCodeTimeout = ''
      return {
        phoneNumber: [
          {
            required: true,
            message: '請填寫手機號碼',
            trigger: 'blur',
          },
          {
            pattern: isTaiwan ? /^09\d{8}$/ : '',
            message: '格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: '請輸入 Email',
          },
          {
            type: 'email',
            message: '請輸入正確的 Email 格式',
          },
        ],
        fullName: [
          {
            required: false,
            message: '請輸入使用人姓名',
          },
        ],
        gender: [
          {
            required: true,
            message: '請選擇性別',
          },
        ],
        productId: [
          {
            required: true,
            message: '請選擇服務地點',
          },
        ],
        productId2: [
          {
            required: true,
            message: '請選擇服務地點',
          },
        ],
        params: [
          {
            required: true,
            message: '請選擇服務項目',
          },
        ],
        bankType: [
          {
            required: true,
            message: '請選擇轉帳銀行',
          },
        ],
        petId: [
          {
            required: true,
            message: `請選擇${this.$t('reserve.CLIENT')}`,
          },
        ],
        city: [
          {
            required: this.isHomeService,
            message: '請選擇縣市',
          },
        ],
        district: [
          {
            required: this.isHomeService,
            message: '請選擇區域',
          },
        ],
        address: [
          {
            required: this.isHomeService,
            message: '請輸入服務地址',
            trigger: 'blur',
          },
        ],
        couponCode: [
          {
            validator: (rule, value, callback) => {
              clearTimeout(validCodeTimeout)
              if (value === '') {
                this.$refs.couponForm.clearValidate('couponCode')
                return callback()
              }
              if (this.previousCouponCode === this.submitData.couponCode) return callback()
              validCodeTimeout = setTimeout(() => {
                this.previousCouponCode = this.submitData.couponCode
                this.$store
                  .dispatch('coupon/validCode', {
                    code: value,
                    basePrice: this.submitData.params[0].price,
                    priceId: this.submitData.params[0].priceId,
                    memberId: this.memberInfo.id,
                  })
                  .then((response) => {
                    callback()
                    this.applyCoupon(response.items)
                  })
                  .catch((error) => {
                    this.previousCouponCode = ''
                    callback(new Error(formatStatusMessage(error.status)))
                  })
              }, 500)
            },
            trigger: 'custom',
          },
        ],
      }
    },
    statusIsChanged() {
      return this.defaultValue.paymentStatus !== this.submitData.paymentStatus
    },
    hasCouponInfo() {
      return Object.keys(this.couponInfo).length !== 0
    },
    /**
     * @description 計算出主服務是哪些
     */
    mainService() {
      if (this.containerEdit) {
        return paramsItem()
      }
      const types = ['cosmetic', 'daycare']
      const service = this.submitData.params.filter((item) => {
        return types.includes(item.type)
      })
      return service.length > 1 ? service : service[0]
    },
    serviceTotal() {
      return this.composeTotal(this.mainService)
    },
    couponPriceTotal() {
      const calcFixedDiscount = (value = 0, total = 0) => Math.max(0, total - value)
      const calcPercentDiscount = (value = 0, total = 1) => total - Math.round(total * (value / 100))

      let basePriceTotal = this.serviceTotal
      const { discount, type } = this.couponInfo || {}

      // 沒有優惠券
      if (!this.hasCouponInfo) {
        return basePriceTotal
      }

      // 應用折扣函數
      const applyDiscount = (price) => (type === 'fixed' ? calcFixedDiscount(discount, price) : calcPercentDiscount(discount, price))

      // 如果是多筆服務，僅第一筆套用優惠券
      if (Array.isArray(basePriceTotal) && basePriceTotal.length) {
        return basePriceTotal.map((price, index) => (index === 0 ? applyDiscount(price) : price))
      }

      // 單一服務
      return applyDiscount(basePriceTotal)
    },
    /**
     * @description 要提交出去的錢
     */
    submitPriceTotal() {
      // let total = this.couponPriceTotal[0] || this.couponPriceTotal
      let total = Array.isArray(this.couponPriceTotal) && this.couponPriceTotal.length ? this.couponPriceTotal.reduce((acc, cur) => acc + cur, 0) : this.couponPriceTotal

      if (this.submitData.prepaidOrderUuid || this.submitDataPrepaid.prepaidId) {
        total = 0
      }
      // 非營業時間只加購一次：所以後面會新增一個offLine條件
      this.updateOffLineParams()
      this.updateBasePrice()

      const params = this.submitData.params
      const memberLevelPercent = this.memberLevelDiscount
      return calcTotal({ price: total, totalEditList: params, memberLevelPercent, memberInfo: this.memberInfo, fromText: '左下角應付總額' })
    },
    hasCannotPayByDepositAddition() {
      // return this.additionList.some((item) => !item.canPayByDeposit)
      return false
    },
    /*************** 當前訂單會員等級的折扣 ***************/
    memberLevelDiscount() {
      return this.composeMemberLevelDiscount(this.mainService)
    },
    genderCheck() {
      if (this.memberInfo.gender === 'male') {
        return '先生'
      }
      return '小姐'
    },
    // 確認訂單項目是否變更
    modifyOrderIsChange() {
      // 變更訂單只能在未付款狀態執行，所以原來的訂單不會是包月，因此只要paymentMethod為Prepaid就必定產生變更
      const paymentMethodChange = this.submitData.paymentMethod === 'Prepaid' || this.submitData.params[0].moreType === 'prepaid'
      // 檢查服務數量是否變更
      const addCompare = this.submitData.params.length !== this.originalOrder.params.length
      // 檢查服務項目或次數是否變更
      const serviceCompare = this.submitData.params.some((service, index) => {
        if (index >= this.originalOrder.params.length) return true
        if (!service.id) return true
        return service.id?.toString() !== this.originalOrder.params[index].id?.toString() || service.qty !== this.originalOrder.params[index].qty
      })

      return paymentMethodChange || addCompare || serviceCompare
    },
    currentStoreAlias() {
      return this.$store.state.merchant.cached.alias
    },
  },
  watch: {
    /**
     * @description 看drawer 開啟狀態，取改變x顯示
     */
    drawerOpenType: {
      handler(nvl, ovl) {
        // 有會員or訪客
        if (nvl.autoOpenForGoodsAndVisit || nvl.autoOpenForGoodsAndMember) {
          this.$emit('changeCloseBtnShowStatus', false)
        }
        // 沒有會員的搜尋階段
        if (nvl.autoOpenForGoodsAndNonMember) {
          this.$emit('changeCloseBtnShowStatus', true)
        }
      },
      deep: true,
    },
    totalAllShow(nvl) {
      if (nvl === false) {
        this.flagAddDrawer = false
      }
    },
    memberInfo: 'updateUserByMember',
    userSameAsMember: 'updateUserByMember',
    currentService: {
      handler() {
        if (this.currentService && this.currentService.productId) {
          let byOrder = []
          this.products.some((product) => product.id === this.currentService.productId && (byOrder = product.extrafields.byOrder || []))
          this.submitData.productId = this.currentService.productId
          this.submitData.byOrderExtrafields = this.convertToObject(byOrder)
          this.getDefaultAddress()
        }
      },
      deep: true,
    },
    // 訂單變更模式直接將舊訂單資料渲染
    isModified: {
      async handler(nvl) {
        if (nvl) {
          this.memberInfo = this.modifyMemberInfo
          this.visibleMemberSearch = false
          this.submitData = this.modifyData
          // 原始訂單資料，用來比對訂單是否變更
          this.originalOrder = cloneDeep(this.modifyOrder)
          this.serviceType = 'order'
          this.modifyOrder.params.forEach((service) => {
            if (service.type === 'cosmetic') this.currentServiceCont.push(`服務項目：${service.title}`)
          })
          try {
            this.modifiedLoading = true
            await this.tryToFetchPetList()
            // 取得美容服務資訊
            const { scheduleItems } = await this.$store.dispatch('schedule/fetchList', {
              date: this.modifyOrder.date,
              scheduleItemId: this.modifyOrder.scheduleItem.id,
              types: ['cosmetic'],
              scheduleItemTypes: ['cosmetic'],
            })
            const serviceTime = `${this.modifyOrder.date} ${this.modifyOrder.time}:00`
            const index = scheduleItems.findIndex((item) => item.id === this.modifyOrder.scheduleItem.id)

            if (index === -1) {
              this.modifyProduct = []
              return
            }
            // 找到有排程的服務人員
            const target =
              scheduleItems[index].scheduleDetails.find((detail) => {
                return serviceTime >= detail.startDate && serviceTime <= detail.endDate
              }) || {}

            this.modifyProduct = target && Object.keys(target).length ? target.products : []
          } catch (err) {
            this.modifyProduct = []
            console.error(err)
          } finally {
            this.modifiedLoading = false
          }
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    await this.useDefaultMemberIdFetch()
    const updateHeaderHeight = () => {
      this.$nextTick(() => {
        const interval = setInterval(() => {
          if (document.querySelector(`#${this.orderHeaderId}`) !== null) {
            clearInterval(interval)
            this.headerHeight = document.querySelector(`#${this.orderHeaderId}`).offsetHeight + 40
          }
        }, 500)
      })
    }
    updateHeaderHeight()
    await this.getContainerUuid()
    this.setAutoOpenType()
    await this.loadGoodsOrder()
  },
  beforeDestroy() {
    this.$emit('clearOffLineParams')
    this.isExpired = true
    clearInterval(this.timer) // 在组件销毁之前清除计时器
  },
  methods: {
    /**
     * @description 移除商品
     */
    handleRemoveGoods(goodItem) {
      let { params: oldParams } = this.submitData
      let newParams = oldParams.filter((param) => param.id !== goodItem.id)
      this.$set(this.submitData, 'params', newParams)
    },
    /**
     * @description 把商品加進submitData的params
     */
    addSelectedGoods(goodItem) {
      this.submitData.params = this.submitData.params.filter((item) => item.type === 'goods')
      this.submitData.params.push(goodItem)
    },
    changeLocation() {},
    /**
     * @description 返回項目首頁
     */
    backToItemHome() {
      // 自動開啟 && member正在開啟
      if (this.isAutoOpen) {
        this.resetOpenType()
        this.setAutoOpenType()
        this.showGoodsList = false
        this.visibleMemberSearch = true
      }
    },
    /**
     * @description 從子組件發送出來找點到的服務/儲值金/包月
     */
    emitToLink(item) {
      if (item.key === 'goods' && this.locationValue.length === 0) {
        this.$message.error('請選擇一間分店')
        return
      }
      if (item.key === 'goods' && Object.keys(this.memberInfo).length === 0) {
        this.showGoodsList = true
        this.visibleMemberSearch = false // 按下商品後，memberSearch必定消失
        this.$set(this.drawerOpenType, 'autoOpenForGoodsAndNonMember', false)
        this.$set(this.drawerOpenType, 'autoOpenForGoodsAndMember', false)
        this.$set(this.drawerOpenType, 'autoOpenForGoodsAndVisit', true) // 以訪客模式顯示畫面
        this.$set(this.drawerOpenType, 'normal', false)
        return
      }
      if (item.key === 'goods' && Object.keys(this.memberInfo).length > 0) {
        this.showGoodsList = true
        this.visibleMemberSearch = false
        this.$set(this.drawerOpenType, 'autoOpenForGoodsAndNonMember', false)
        this.$set(this.drawerOpenType, 'autoOpenForGoodsAndMember', true) // 以會員模式顯示畫面
        this.$set(this.drawerOpenType, 'autoOpenForGoodsAndVisit', false)
        this.$set(this.drawerOpenType, 'normal', false)
        return
      }
      this.$emit('emitToLink', item)
    },
    /**
     * @description 顯示會員資訊（但不要有寵物）
     */
    showMemberInfo() {
      this.resetOpenType()
      this.$set(this.drawerOpenType, 'autoOpenForGoodsAndMember', false)
      this.$set(this.drawerOpenType, 'normal', true)
    },
    /**
     * @description 顯示畫面的預設狀態
     */
    resetOpenType() {
      for (const [key, value] of Object.entries(this.drawerOpenType)) {
        this.$set(this.drawerOpenType, key, key === 'normal')
      }
    },
    /**
     * @description 根據autoOpen細分下去該怎麼顯示畫面（畫面源頭）
     */
    setAutoOpenType() {
      if (!this.isAutoOpen) {
        this.resetOpenType()
      } else {
        this.$set(this.drawerOpenType, 'autoOpenForGoodsAndNonMember', true)
        this.$set(this.drawerOpenType, 'normal', false)
      }
    },
    /**
     * @description 分配助理後儲存
     */
    async tryToStoreAssignHelper({ isSpace }) {
      try {
        const { action, itemId } = this.decideActionStatus(isSpace, this.forHelperDefaultData, this.forHelperSubmitData)
        this.tryingAssign = true
        if (action === 'remove-add') {
          await this.storeAssignHelperApiForRemoveAdd(this.forHelperDefaultData, itemId)
        }
        if (action === 'remove') {
          await this.storeAssignHelperApi('remove', itemId, isSpace)
        }
        if (action === 'add') {
          await this.storeAssignHelperApi('add', itemId, isSpace)
        }
        await this.getContainerUuid()
        this.$emit('updateList')
      } catch (error) {
        console.error(error.message)
      } finally {
        this.tryingAssign = false
      }
    },
    /**
     * @description 助理/空間的儲存api
     */
    async storeAssignHelperApi(action, saveId = '', isSpace) {
      try {
        await this.mixinStoreAssignHelperApi(action, saveId, isSpace, this.forHelperDefaultData, this.forHelperSubmitData)
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 試著找到helper list
     */
    async tryToFetchHelperList(isSpace) {
      try {
        await this.mixinTryToFetchHelperList(this.forHelperSubmitData, isSpace)
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 開啟助理編輯
     */
    async openAssignEdit(index, item, type) {
      try {
        this.tryingAssign = true
        await this.seeOrder(item) // 先獲取order 細節
        this.openCloseAssistType(type, true)
        this.openAssistSelect(index, type)
        await this.fetchHelperList(type)
        this.initHelper()
        this.forHelperSubmitData = this.initSpaceHelpers(this.forHelperSubmitData)
        this.forHelperSubmitData = this.initHelpers(this.forHelperSubmitData)
        this.forHelperDefaultData = cloneDeep(this.forHelperSubmitData)
      } catch (error) {
        console.error(error.message)
      } finally {
        this.tryingAssign = false
      }
    },
    async fetchHelperList(type) {
      if (type === 'prices') {
        await this.tryToFetchHelperList(0)
      }
      if (type === 'space') {
        await this.tryToFetchHelperList(1)
      }
    },
    /**
     * @description 查看訂單(針對此訂單做修改)
     */
    async seeOrder(item, type) {
      try {
        if (Object.keys(item).length > 0) {
          this.forHelperSubmitData = await this.$store.dispatch('order/fetchSingle', item.orderId)
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    initHelper() {
      if (!this.forHelperSubmitData?.helper) {
        this.forHelperSubmitData.helper = {
          id: '',
          name: '',
        }
      }
    },
    /**
     * @description 如果有非營業預約加價，以及params目前沒有這個offtime加價，則push進去
     * 1. 如果有this.offLineParams才要push
     * 2. some判斷說，是否有被加進去過了
     */
    updateOffLineParams() {
      if (this.offLineParams && Object.keys(this.offLineParams).length > 0 && !this.submitData.params.some((item) => item.moreType === 'offTime') && !this.containerEdit && !this.totalAllShow) {
        this.submitData.params.push(this.offLineParams)
      }
    },
    /**
     * @description 取得containerUUid
     */
    async getContainerUuid() {
      try {
        if (Object.keys(this.memberInfo).length === 0) return
        const { items } = this.memberInfo.orderContainers
        const bookingOrders = items.filter((item) => item.type === 'booking')
        if (bookingOrders.length > 0) {
          this.containerOrders = await this.$store.dispatch('order/fetchContainerList', bookingOrders[0].uuid)
          await this.getCosmeticBasicToSetTempTime()
          this.orderContainerUuid = bookingOrders[0].uuid
          this.computedOrderOverTime()
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 選擇單筆訂單之後，開始加購
     */
    async selectOrderAndAddition(item = {}, type) {
      if (Object.keys(item).length === 0 && type === 'newOrder') {
        this.selectSingleOrder = false
        this.containerEdit = false
        this.thisTimeModiOrderId = '' // 一切從0開始加購，所以id要先清掉
      }
      if (Object.keys(item).length > 0 && type === 'oldOrder') {
        const { params } = item
        this.cloneParamsId()
        this.$set(this.submitData, 'params', params) // 然後將新服務換掉變成已經有的服務
        this.thisTimeModiOrderId = item.id // 把使用者點選的orderId記起來，等等要打API
        this.selectSingleOrder = false
        this.containerEdit = false
      }
      // 總訂單的加購
      if (Object.keys(item).length === 0 && type === 'all') {
        this.cloneParamsId()
        const result = this.decideIdAndParams()
        this.containerOrders.params = cloneDeep(result.params)
        this.$set(this.submitData, 'id', this.containerOrders.displayId)
        this.$set(this.submitData, 'params', this.containerOrders.params)
        this.thisTimeModiOrderId = this.containerOrders.displayId // 把使用者點選的orderId記起來，等等要打API
        this.selectSingleOrder = false
        this.containerEdit = true
      }
    },
    /**
     * @description 決定要顯示哪個總訂單的資訊
     */
    decideIdAndParams() {
      try {
        const result = {
          id: '',
          params: [],
          total: 0,
        }
        const { orders } = this.containerOrders
        result['id'] = this.containerOrders['displayId']
        result['params'] = cloneDeep(this.containerOrders['params'])
        result['total'] = orders.reduce((accu, cur) => {
          return accu + cur.payTotal
        }, 0)
        result['params'].unshift({
          type: 'cosmetic',
          title: '總價',
          priceId: 'fake',
          price: result['total'],
          qty: 1,
          total: result['total'],
        })

        return result
      } catch (error) {
        console.error(error.message)
      }
    },
    cloneParamsId() {
      this.tempOriginalParams = cloneDeep(this.submitData.params) // 先暫存使用者新增的服務
      this.tempOriginalId = this.submitData.id
    },
    /**
     * @description 如果localStorage有memberId資訊，預先帶入
     */
    async useDefaultMemberIdFetch() {
      const memberId = await getSavedState('containerMemberId')
      const guestCheck = memberId === this.$store.state.merchant.cached.guest
      if (!memberId || guestCheck) return
      if (memberId.length > 0) {
        await this.tryToFetchDetail(memberId)
      }
    },
    scrollToBottom() {
      if (this.$refs.leftCont) {
        this.$nextTick(() => {
          this.$refs.leftCont.scrollTop = 1000
        })
      }
    },
    /**
     * @description 點擊寵物Tab
     */
    handleClickPetTab() {
      if (this.activeName === '0') {
        return
      }
      this.handleClickPetTabMixin(this.containerGroupPetId, 'noPlus')
    },
    /**
     * @description 付款方式為deposit
     */
    async paymentWayDeposit() {
      try {
        const mainOrderTotal = this.isBuyPrepaid ? this.submitDataPrepaid.price : this.submitPriceTotal
        const isDepositInsufficient = this.depositReduce < mainOrderTotal

        if (!this.currentService.canPayByDeposit) {
          await this.$confirm(`${this.hasCannotPayByDepositAddition ? '加購項目中某幾項' : '此方案'}未設定可使用儲值點數抵扣，請問是否確定抵扣 ${mainOrderTotal} 點？`, '抵扣未開放', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        } else {
          await this.$confirm(`確定要使用儲值金抵扣 ${mainOrderTotal} 點？`, '提醒', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        }

        if (isDepositInsufficient) {
          await this.isDepositInsufficientAlertWindow()
          this.createDepositOrderVisible = true
          return
        }
        if (this.isBuyPrepaid) this.submitDataPrepaid.paymentMethod = 'Deposit'
        this.submitData.paymentMethod = 'Deposit'
        this.goToExtrafields(true)
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 新增預約儲存按鈕（似乎不會用到了）
     */
    async handleStoreOrder(type) {
      const isNegative = this.submitPriceTotal < 0
      // 金額負數要先提醒
      if (isNegative) {
        this.$confirm('訂單金額不能小於0', '提醒', {
          confirmButtonText: '確定',
          showCancelButton: false,
          type: 'warning',
          center: true,
        })
        return
      }
      // 儲值金流程
      if (this.paymentWay === 'Deposit') {
        this.paymentWayDeposit()
        return
      }
      // 線下付款 or 線上付款都走這邊
      if (this.paymentWay === 'offline' || this.paymentWay === 'online') {
        this.paymentDialogVisible = true
        return
      }
      // 若為包月方案預約，直接跳到備註
      if (this.paymentWay === 'Prepaid' && this.serviceType === 'prepaid-order') {
        this.goToExtrafields(true)
      }
    },
    /**
     * @description 創建一筆新訂單
     */
    async handleCreateOrder() {
      try {
        const isBeforeExpired = this.memberInfo.level.expiredAt === null || new Date() <= new Date(formatGetTime(this.memberInfo.level.expiredAt))
        if (!isBeforeExpired) return this.errorCurrentMemberLevel()
        this.submitDataPrepaid.prepaidId ? this.tryToCreatePrepaidOrder() : this.tryToCreateOrder()
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 相關問答儲存
     * purpose：相關問答儲存
     */
    async tryToSaveOrder() {
      // await this.$refs.extraForm.validate() // 新的問答不用驗證這個
      const { params, ...other } = this.currentOrder
      let storeData = {}

      storeData = {
        ...this.convertExtraFieldToStoreDataFromEditMode({
          ...other,
        }),
        merchantNote: '',
      }
      this.tryingStore = true
      try {
        await this.$store.dispatch('order/store', storeData)
        this.closeExtraDialogVisible()
      } catch (error) {
        this.$message({
          type: 'error',
          message: `Server Error`,
        })
      } finally {
        this.tryingStore = false
      }
    },
    /**
     * @description for 修改時的相關問答
     */
    convertExtraFieldToStoreDataFromEditMode(submitData, passQ = false) {
      const orderInfo = cloneDeep(submitData)
      const getExtraFieldsArray = (extraFields) => {
        const extraFieldsArray = []
        const isEdited = (field) => {
          return true
        }
        Object.keys(extraFields).forEach((extraFieldsId) => {
          if (isEdited(extraFields[extraFieldsId])) {
            const { id, value } = extraFields[extraFieldsId]
            extraFieldsArray.push({
              id: id,
              value: passQ ? '' : value,
            })
          }
        })
        return extraFieldsArray
      }
      const getBySizeExtraFieldsArray = (customerInfos) => {
        return customerInfos.map((customerInfo) => {
          return {
            customerInfoId: customerInfo.customerInfoId,
            orderExtrafields: getExtraFieldsArray(customerInfo.bySizeExtrafields),
          }
        })
      }

      if (orderInfo.byOrderExtrafields) {
        orderInfo.byOrderExtrafields = getExtraFieldsArray(orderInfo.byOrderExtrafields)
      }
      if (orderInfo.customerInfos) {
        orderInfo.bySizeExtrafields = getBySizeExtraFieldsArray(orderInfo.customerInfos)
      }
      if (orderInfo.customerInfos) delete orderInfo.customerInfos
      return orderInfo
    },
    errorCurrentMemberLevel() {
      this.$alert(`超過會員等級方案"${this.memberInfo.level.title}"截止時間，請重新下單`, {
        title: `提示`,
        showClose: false,
        dangerouslyUseHTMLString: true,
      }).then(() => {
        this.tryToFetchDetail(this.memberInfo.id)
      })
    },
    /**
     * @description 僅僅單筆預約，然後cb是做checkout container
     */
    async storeSingleOrder(cb, status) {
      try {
        this.storeSingleOrderStatus = true
        const { type } = this.submitData.params[0]
        // 然後要找出params的第一筆type
        this.$set(this.submitData, 'type', type)
        // 因為是單筆預約，要放入container，所以要將paymentMethod先清空
        this.$set(this.submitData, 'paymentMethod', '')
        if (this.isBuyPrepaid) {
          // 購買包月＋同時預約
          await this.tryToCreatePrepaidOrder()
        } else {
          // 純預約
          this.propsLoading = true
          await this.tryToCreateOrder('', status)
        }
        await this.getOrder()
        if (!this.relatedQuestionPopWindow && !this.payListStop) {
          await cb()
        }
      } catch (error) {
        this.propsLoading = false
        console.error(error.message)
        throw new Error(error)
      } finally {
        this.payListStop = false
      }
    },

    /**
     * @description 單筆預約與關閉抽屜
     */
    async storeSingleOrderAndCloseDrawer() {
      try {
        await this.validateFullName(this.submitData.fullName)
        const result = await this.negativeAlert(this.submitPriceTotal)
        if (result) {
          // 一次增加多個訂單（假資料）
          // for(let i = 0, len = 3 ; i < len ; i++){
          //   await this.storeSingleOrder(() => { })
          // }
          await this.storeSingleOrder(() => {}) // 儲存這個訂單
          if (!this.isModified) await saveState('containerMemberId', this.submitData.memberId) // 將這次儲存的memberId放進去localStorage
          this.emitStore()
        }
      } catch (error) {
        console.error(error.message)
      } finally {
        this.storeSingleOrderStatus = false
      }
    },
    /**
     * @description 單筆預約與關閉抽屜
     */
    async createOrderQuickly(status) {
      try {
        await this.validateFullName(this.submitData.fullName)
        const result = await this.negativeAlert(this.submitPriceTotal)
        if (result) {
          await this.storeSingleOrder(() => {}, status)
        }
      } catch (err) {
        console.error(err.message)
      } finally {
        this.quicklyDialogVisible = false
        this.storeSingleOrderStatus = false
        this.emitStore()
      }
    },
    /**
     * @description 組成問題格式
     */
    composeRawExtraField() {
      return this.beforeApiExtraFields.reduce((acc, cur) => {
        acc[cur.id] = cur
        return acc
      }, {})
    },
    /**
     * @description 新增一筆一般訂單
     */
    async tryToCreateOrder(merchantNote = '', status) {
      const orderExtrafields = this.productHasExtraField ? this.convertExtraFieldToStoreDataFromCreateMode() : undefined
      let storeData = {
        ...this.submitData,
        id: 'fakeId', // 為了模仿edit的相關問答
        basePrice: this.basePrice,
        total: this.submitPriceTotal,
        groupSize: 1,
        merchantNote,
        orderExtrafields, // 組新增問題格式使用
        byOrderExtrafields: this.composeRawExtraField(), // 組相關問答列表顯示的窗
        startDate: `${formatDate(this.scheduleDetail.date, 'date-dash')} ${formatDate(this.scheduleDetail.date, 'time')}`,
        scheduleItemId: this.scheduleDetail.id,
        isSpecifyScheduleItem: this.staffSpecify === 'specify',
      }

      // 變更訂單資料
      if (this.isModified) {
        storeData.startDate = `${this.modifyOrder.date} ${this.modifyOrder.time}`
        storeData.byOrderExtrafields = this.modifyOrder.byOrderExtrafields
        storeData.paymentMethod = this.modifyOrder.paymentMethod
        delete storeData.id
        storeData.cancel_order_id = this.modifyOrder.id
        if (storeData.paymentMethod === 'Prepaid') storeData.paymentStatus = 'PAID'
        await this.$store.dispatch('order/store', storeData)
        await saveState('containerMemberId', '')
        this.$emit('store')
        return
      }

      storeData = await this.addExtraFieldValue(storeData) // 為了將相關問答塞進去儲存資料
      this.tryingStore = true
      try {
        delete storeData.id
        let serverTime = ''
        await this.tryToSaveAddress()
        await this.$store.dispatch('order/store', storeData).then((res) => {
          this.orderContainerUuid = res.items.orderContainerUuid || ''
          this.currentOrderId = res.items.id
          // 取得伺服器時間
          serverTime = moment(res.items.createdAt)
        })

        // 取得本地時間
        const localTime = moment()
        // console.log('本地時間', localTime, '伺服器時間', serverTime, '時間差', localTime.diff(serverTime))
        // 時間差超過一秒則將差值存入local storage
        if (Math.abs(localTime.diff(serverTime)) > 1000) localStorage.setItem('diffTime', localTime.diff(serverTime))

        // 快速建立訂單
        if (status === 'UNPAID') {
          await this.payingOrderOmitMethod(status, storeData)
        }

        // 如果非單筆儲存流程，就直接往下走
        if (!this.storeSingleOrderStatus) {
          let requirePay = storeData.paymentStatus === 'PAID' ? false : storeData.paymentStatus === 'UNPAID' && storeData.total > 0
          this.handleCreateSuccess(requirePay)
        }
      } catch (error) {
        if (error.status === 'SCHEDULE_ITEM_CALENDAR_TIME_UNAVAILABLE') {
          this.$message({
            type: 'warning',
            message: `與該訂單時段重疊： ${formatDate(new Date(error.data.date), 'dateTime')}`,
          })
        }

        if (error.status === 'SCHEDULE_ITEM_ADMIN_ITEM_NOT_EXIST') {
          this.$message({
            type: 'error',
            message: `此排班不存在或該排班人員不存在`,
          })
        } else {
          console.error(error.message)
          throw new Error(error)
        }
      } finally {
        this.tryingStore = false
      }
    },
    /**
     * @description 省略付款走這裡
     */
    async payingOrderOmitMethod(status, data) {
      this.tryingStore = true

      try {
        const { fullName, gender, phoneCode, phoneNumber } = data

        // 獲取訂單容器列表
        const order = await this.$store.dispatch('order/fetchContainerList', this.orderContainerUuid)

        // 計算總價
        const total = order.orders.reduce((acc, cur) => acc + cur.allTotal, 0)

        const payload = {
          ...order,
          paymentMethod: '',
          paymentStatus: status,
          fullName,
          gender,
          phoneCode,
          phoneNumber,
          total,
        }

        await this.$store.dispatch('order/storeContainerId', payload)
      } catch (err) {
        console.error(err)
      } finally {
        this.tryingStore = false
        await saveState('containerMemberId', '')
      }
    },
    /**
     * @description 開啟相關問答，並且把值塞進去
     */
    async addExtraFieldValue(storeData) {
      try {
        this.currentOrder = storeData // 把資料丟給currentOrder：為了讓相關問答的窗跳出來
        await this.controlRelatedQuestionPopWindow() // 等待開窗結果（注意這裡面會修改currentOrder）
        this.setUndefinedOrderExtrafields()
        return this.currentOrder // 開窗結果之後，再丟回去storeData
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 如果orderExtrafields 是undefined，則設定為[]，不然會存不過去
     */
    setUndefinedOrderExtrafields() {
      if (!this.currentOrder.orderExtrafields) {
        this.$set(this.currentOrder, 'orderExtrafields', [])
      }
    },
    /**
     * @description 取得訂單內容
     */
    async getOrder() {
      if (this.currentOrderId) {
        const updatedValue = await this.$store.dispatch('order/fetchSingle', this.currentOrderId)
        this.currentOrder = cloneDeep(updatedValue)
        this.orderContainerUuid = this.currentOrder.orderContainerUuid
      }
    },
    /**
     * @description 控制相關問答開窗
     */
    async controlRelatedQuestionPopWindow() {
      return new Promise((resolve, reject) => {
        // 如果有相關問答，跳窗＋resolve 存著
        if (this.productHasExtraField) {
          this.relatedQuestionPopWindow = true
          this.stopCloseDrawer = () => {
            this.relatedQuestionPopWindow = false
            resolve(true)
          }
          this.relatedCloseReject = () => {
            this.payListStop = true
            reject(new Error('使用者關閉'))
          }
        } else {
          resolve(true)
        }
      })
    },

    /**
     * @description 創建包月訂單
     */
    async tryToCreatePrepaidOrder(merchantNote = '') {
      const orderExtrafields = this.productHasExtraField ? this.convertExtraFieldToStoreDataFromCreateMode() : undefined
      const orderData = {
        ...this.submitData,
        id: 'fakeId', // 為了模仿edit的相關問答
        basePrice: this.basePrice,
        total: this.submitPriceTotal,
        groupSize: 1,
        merchantNote,
        orderExtrafields, // 組新增問題格式使用
        byOrderExtrafields: this.composeRawExtraField(), // 組相關問答列表顯示的窗
        startDate: `${formatDate(this.scheduleDetail.date, 'date-dash')} ${formatDate(this.scheduleDetail.date, 'time')}`,
        scheduleItemId: this.scheduleDetail.id,
      }
      let prepaidData = {
        ...this.submitDataPrepaid,
        email: this.memberInfo.email,
        fullName: this.memberInfo.fullName,
        gender: this.memberInfo.gender,
        memberId: this.memberInfo.id,
        phoneCode: this.memberInfo.phoneCode,
        phoneNumber: this.memberInfo.phoneNumber,
        taxType: this.memberInfo.taxType,
        taxId: this.memberInfo.taxId,
        LoveCode: this.memberInfo.LoveCode,
        merchantNote,
        note: orderData.note,
        params: [
          {
            title: this.submitDataPrepaid.title,
            type: 'prepaid-plan',
            description: '',
            priceId: this.submitDataPrepaid.prepaidId,
            price: this.submitDataPrepaid.price,
            qty: 1,
          },
        ],
        basePrice: this.submitDataPrepaid.price,
        total: this.formatMemberLevelPrepaidPrice(), // 經由computed直接計算購買包月的價錢
        order: {
          ...orderData, // 注意包月這邊，prepaidOrder內，包含真正的order
          isSpecifyScheduleItem: this.staffSpecify === 'specify',
        },
        paymentMethod: '',
      }
      prepaidData.order = await this.addExtraFieldValue(prepaidData.order) // 為了將相關問答塞進去儲存資料
      this.tryingStore = true
      try {
        delete prepaidData.order.id
        await this.tryToSaveAddress()
        await this.$store.dispatch('prepaid/storeOrder', prepaidData).then((res) => {
          this.currentOrderId = res.items.deductOrders[0].id
        })
        let requirePay = prepaidData.status === 1 ? false : prepaidData.status === 2
        if (this.prepaidPrice === 0) {
          requirePay = false
        }
        if (!this.storeSingleOrderStatus) {
          this.handleCreateSuccess(requirePay)
        }
      } catch (error) {
        console.error(error.message)
      } finally {
        this.tryingStore = false
      }
    },
    handleCreateSuccess(requirePay = false) {
      this.$alert(`已發送${requirePay ? '付款' : '訂單'}連結至使用人 Email`, '訂單新增成功！', {
        confirmButtonText: '確認',
        center: true,
      }).finally(() => {
        this.extraDialogVisible = true
      })
    },
    /**
     * @description 似乎不會用到了
     */
    onSubmitPaymentForm(data) {
      const { paymentMethod, Card4No, PayerAccount5Code, bankType, isPaid } = data

      if (this.isPrepaidAndTotalEdit && !this.submitData.prepaidOrderUuid) this.submitData.prepaidOrderUuid = ''

      if (this.submitDataPrepaid.prepaidId) {
        this.submitDataPrepaid = {
          ...this.submitDataPrepaid,
          paymentMethod,
          Card4No,
          PayerAccount5Code,
          bankType,
        }
      }

      this.submitData = {
        ...this.submitData,
        paymentMethod,
        Card4No,
        PayerAccount5Code,
        bankType,
      }
      this.goToExtrafields(isPaid)
    },
    goToExtrafields(isPaid) {
      if (!this.submitDataPrepaid.prepaidId) {
        isPaid ? (this.submitData.paymentStatus = 'PAID') : (this.submitData.paymentStatus = 'UNPAID')
      } else {
        if (isPaid) {
          this.submitDataPrepaid.status = 1
          this.submitData.paymentStatus = 'PAID'
        } else {
          this.submitDataPrepaid.status = 2
          this.submitData.paymentStatus = 'UNPAID'
        }
      }

      this.paymentDialogVisible = false
      if (!this.submitData.fullName) {
        this.userSameAsMember = false
      } else {
        this.userSameAsMember = true
      }
      this.handleCreateOrder()
    },
    emitStore() {
      this.$emit('store')
    },
    convertToObject(extraFields) {
      if (extraFields === null) return
      const fields = {}
      extraFields.forEach((field) => {
        fields[field.id] = {
          group: 1,
          id: field.id,
          Alias: '',
          value: '',
          title: field.title,
        }
      })
      return fields
    },
    /**
     * @description 新增的時候增加問題
     */
    convertExtraFieldToStoreDataFromCreateMode() {
      let byOrderList = []
      let bySizeList = []
      const byOrderExtrafields = {}
      byOrderList = Object.keys(byOrderExtrafields).map((id) => {
        return byOrderExtrafields[id]
      })
      return [...byOrderList, ...bySizeList]
    },
    /**
     * @description 點選價格與編輯btn -> 開啟價格與編輯drawer
     */
    openTotalEdit() {
      this.totalAllShow = true
      this.selectSingleOrder = true
      this.visibleAdditionForm = false
    },
    /**
     * @description 開啟價格編輯與折扣
     */
    openPriceEditAndDiscount() {
      try {
        if (this.isAutoOpen) {
          this.totalAllShow = true // 打開加減價
          this.selectSingleOrder = false // 選擇訂單畫面
          this.visibleAdditionForm = false // 看加購的Form
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 加購btn -> 開啟加購drawer
     */
    openAddDrawer() {
      this.flagAddDrawer = true
      this.thisTimeModiOrderId = '' // 一切從0開始加購，所以id要先清掉
      this.totalAllShow = true
      this.selectSingleOrder = true // 選擇單筆訂單的視窗
      this.visibleAdditionForm = true // 加購分頁
    },
    /**
     * @description 從加購視窗開啟加購
     */
    openAddEdit() {
      this.totalAllShow = true
      this.visibleAdditionForm = true
    },
    /**
     * @description 從drawer 開啟加購視窗
     */
    openAddEditOuter() {
      this.thisTimeModiOrderId = '' // 一切從0開始加購，所以id要先清掉
      this.totalAllShow = true
      this.selectSingleOrder = true // 選擇單筆訂單的視窗
      this.visibleAdditionForm = true // 加購分頁
    },
    closeAdd() {
      this.visibleAdditionForm = false
    },
    /**
     * @description 關閉 加價/變價drawer
     */
    closeTotalAll() {
      try {
        this.resetSubmitDataParamsId()
        this.cancelToTalEdit()
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 復原使用者原本選的細節
     */
    resetSubmitDataParamsId() {
      try {
        if (this.tempOriginalParams.length > 0) {
          this.submitData.params = cloneDeep(this.tempOriginalParams)
        }
        if (this.tempOriginalId) {
          this.submitData.id = this.tempOriginalId
        } else {
          // 如果原本沒有id（代表新增），則復原為空
          this.submitData.id = ''
        }
        this.containerEdit = false
        this.tempOriginalParams = []
        this.tempOriginalId = ''
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 按下加購左下角的儲存按鈕
     */
    async saveTotalEdit() {
      try {
        const negativeStatus = await this.negativeAlert(this.submitPriceTotal)
        if (!negativeStatus) return
        // 舊訂單編號
        if (this.thisTimeModiOrderId === '') {
          this.totalAllShow = false // 關閉加價購
          return
        }
        const data = {
          adds: this.tempUpdateParams.params.filter(({ id }) => id === undefined),
          deleteIds: this.tempUpdateParams.deleteIds,
          couponCode: this.submitData.couponCode,
          orderId: this.thisTimeModiOrderId,
          total: this.submitPriceTotal,
        }
        const result = await this.$store.dispatch('order/storeOrderItem', data)
        if (result.code === 200) {
          this.$message({
            type: 'success',
            message: '編輯成功！',
          })
          await this.getContainerUuid()
          this.resetSubmitDataParamsId()
          this.totalAllShow = false // 關閉加價購
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    cancelToTalEdit() {
      this.totalAllShow = false
    },
    applyCoupon(couponData) {
      this.couponInfo = couponData
    },
    validCoupon() {
      this.$refs.couponForm.validateField('couponCode')
    },
    resetCoupon() {
      this.couponInfo = {}
      this.submitData.couponCode = ''
      this.previousCouponCode = ''
      this.$refs.couponCode.resetField('couponCode') // 留意
      this.submitData.couponCode = '' // resetField 有時不會work 所以還要清空couponCode
    },
    addTotalEdit(item) {
      const list = [...this.totalEditList]
      list.push({
        ...item,
      })
      this.totalEditList = [...list]
      this.prepaidAndEdit()
    },
    openAddressEdit() {
      this.closeLayout()
      this.addressShow = true
    },
    closeAddress() {
      this.addressShow = false
    },
    getDefaultAddress() {
      if (this.memberInfo.shippingInfo && this.memberInfo.shippingInfo[0] && this.memberInfo.shippingInfo[0].district) {
        const addressOk = this.filterCities.some((item) => {
          return item.district.includes(this.memberInfo.shippingInfo[0].district)
        })
        if (addressOk) {
          const { city, district, address } = this.memberInfo.shippingInfo[0]
          this.submitData.city = city
          this.submitData.district = district
          this.submitData.address = address
        }
      }
    },
    async saveHomeAddress({ syncAddress, data }) {
      const { city, district, address } = data
      this.submitData.city = city
      this.submitData.district = district
      this.submitData.address = address
      this.enableSaveAddress = syncAddress
      this.addressShow = false
    },
    async tryToSaveAddress() {
      if (this.enableSaveAddress) {
        let data = {
          address: this.submitData.address,
          city: this.submitData.city,
          district: this.submitData.district,
          email: '',
          name: '',
          phone: '',
          postcode: '',
        }
        data.postcode = findDistrictZip(this.submitData.city, this.submitData.district)
        await this.$store.dispatch('member/store', {
          id: this.memberInfo.id,
          fullName: this.memberInfo.fullName,
          gender: this.memberInfo.gender,
          shippingInfo: [data],
        })
      }
    },
    async onCreateDepositOrderDone() {
      this.$refs.depositOrderForm.closeDrawer()
      await this.tryToFetchDetail(this.memberInfo.id)
    },
    resetService() {
      const resetHomeServiceAddress = () => {
        this.addressShow = false
        this.submitData.city = ''
        this.submitData.district = ''
        this.submitData.address = ''
      }

      this.submitData.prepaidOrderUuid = ''
      this.submitDataPrepaid.prepaidId = ''
      this.submitData.params = [paramsItem()]
      this.currentService = null
      this.currentServiceCont = []

      resetHomeServiceAddress()
    },
    closeLayout() {
      this.visibleMemberDetailEdit = false
      this.memberInfoShow = false
      this.petShow = false
      this.serviceShow = false
      this.addressShow = false
      this.visibleAdditionForm = false
    },
    closeAllInfo() {
      this.memberInfoShow = false
      this.petShow = false
      this.serviceShow = false
    },
    /**
     * @description 選擇服務方式btn 點下去（單次預約or包月）
     * @param {*String} type
     */
    onSelectServiceType(type) {
      this.serviceType = type
      if (this.serviceType !== type) {
        this.resetService()
      }
      this.closeAllInfo()
      this.openRightSelectService()
    },
    /**
     * @description onSelectServiceType btn 點下去之後，右側出現的視窗控制
     */
    openRightSelectService() {
      this.resetService()
      if (this.serviceType === 'order') {
        this.serviceShow = true
        this.prepaidAllShow = false
      }
      if (this.serviceType === 'prepaid-order') {
        this.serviceShow = false
        this.prepaidAllShow = true
      }
    },
    /**
     * @description 刪除此筆服務（只能用來刪除舊有訂單）
     */
    async deleteRightSelectService(item) {
      try {
        const { orderId } = item
        await this.$store.dispatch('order/deleteOrderItem', {
          ids: [orderId],
        })
        await this.useDefaultMemberIdFetch()
        this.activeName = '0'
        this.$set(this.submitData, 'petId', '')
        await this.getContainerUuid()
        if (this.containerGroupPetId.length === 0) {
          await saveState('containerMemberId', '')
        }
        this.$emit('updateList')
      } catch (error) {
        console.error(error.message)
      }
    },
    updateBasePrice() {
      const params = this.submitData.params
      let price = 0
      if (Array.isArray(this.mainService) && this.mainService.length) {
        price = this.mainService.reduce((total, service) => total + service.price * service.qty, 0)
      } else {
        price = this.mainService.price * this.mainService.qty
      }
      this.basePrice = calcBasePrice({ price, totalEditList: params })
    },
    /**
     * @description 使用包套方案抵扣
     */
    onSelectedPrepaid({ prepaid, prepaidService, isPrepaidBonus }) {
      this.submitDataPrepaid.prepaidId = ''

      this.submitData.prepaidOrderUuid = prepaid.id
      this.submitData.params = [this.setParams(prepaidService, 'prepaid')]
      this.submitData.paymentMethod = 'Prepaid'
      this.submitData.isPrepaidBonus = isPrepaidBonus

      this.paymentWay = 'Prepaid'
      this.currentService = prepaidService
      this.currentServiceCont.push(`${this.$t('prepaid.BASE')}方案：${prepaid.prepaidTitle}  |  服務項目：${prepaidService.title}`)
      this.afterPrepaidSelected()
    },
    // 購買包套方案並且同時抵扣
    onSelectedBuyingPrepaid({ prepaid, prepaidService }) {
      try {
        this.submitDataPrepaid.prepaidId = prepaid.id
        this.submitDataPrepaid.price = prepaid.price
        this.submitDataPrepaid.title = prepaid.title
        this.submitDataPrepaid.type = 'prepaid'

        this.submitData.prepaidOrderUuid = ''
        this.submitData.params = [this.setParams(prepaidService, 'prepaid')]
        this.submitData.paymentMethod = 'Cash'

        this.paymentWay = 'offline'
        this.currentService = prepaidService
        // this.currentServiceCont = `${this.$t('prepaid.BASE')}方案：${prepaid.title}  |  服務項目：${prepaidService.title}`
        this.currentServiceCont.push(`${this.$t('prepaid.BASE')}方案：${prepaid.title}  |  服務項目：${prepaidService.title}`)
        this.afterPrepaidSelected()
      } catch (error) {
        console.error(error.message)
      }
    },
    afterPrepaidSelected() {
      this.prepaidAllShow = false
      this.isPrepaidAndTotalEdit = false
      this.scrollToBottom()
    },
    closePrepaidAll() {
      if (!this.currentService?.id) {
        this.serviceType = ''
      }
      if (!this.submitData.prepaidOrderUuid && !!this.currentService?.id) {
        this.serviceType = 'order'
      }
      this.prepaidAllShow = false
      this.scrollToBottom()
    },
    prepaidAndEdit() {
      if (this.submitData.paymentMethod === 'Prepaid') {
        this.submitData.paymentMethod = ''
        this.paymentWay = 'offline'
        this.isPrepaidAndTotalEdit = true
      }
    },
    /************ 包套方案相關 end ************/

    /************ 寵物資訊相關 start ************/
    closePet() {
      this.petShow = false
      this.serviceType = ''
      this.isShowPetList = true
      this.scrollToBottom()
    },
    /**
     * @description 右側的寵物列表清單
     * @param {@number} id
     */
    selectPet(id) {
      this.submitData.petId = id
      this.petShow = false
      this.resetService()
      this.handleClickPetTabReverseBridge()
    },
    handleClickPetTabReverseBridge() {
      this.handleClickPetTabReverse('add')
    },
    /**
     * @description 關閉
     */
    handleBeforeQClose(done) {
      this.relatedCloseReject()
      done()
    },
    /**
     * @description 儲存相關問答
     */
    async qBtn(passQ) {
      let orderInfo = this.convertExtraFieldToStoreDataFromEditMode(cloneDeep(this.currentOrder), passQ)
      this.$set(this.currentOrder, 'orderExtrafields', orderInfo.byOrderExtrafields)
      await this.stopCloseDrawer()
    },
    /**
     * @description 寵物資訊 -> 開啟查看相關問答
     */
    openRelatedQ() {
      this.petShow = false
    },
    /**
     * @description 完成預約，之後要開啟非營業時段結束安親確認
     */
    completeReserveFunc() {
      try {
        if (this.submitData.params && this.submitData.params.length > 0) {
          this.newOrderId = this.currentService.id
          this.newOrderInfo = this.currentService
        }
        if (this.testOverTime()) {
          this.overTimeReserveWindowStatus = true
        } else {
          this.serviceShow = false
          this.completeResAndPayBtn = true
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 關閉非營業時段結束安親確認
     */
    offTimeReserveResolveFunc(params) {
      try {
        this.overTimeParams = params
        if (Object.keys(params).length > 0) {
          this.submitData.params.push(this.overTimeParams)
        }
        this.overTimeReserveWindowStatus = false
        this.serviceShow = false
        this.completeResAndPayBtn = true
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 完成預約立即付款
     */
    async completeReserveAndPay() {
      const result = await this.negativeAlert(this.submitPriceTotal)
      if (result) {
        this.serviceShow = false
        this.completeReserveAndPayStatus = true
      }
    },
    /**
     * @description 左邊寵物資訊的「重選寵物btn」
     */
    openSelectPet() {
      this.closeAllInfo()
      this.serviceType = ''
      this.petShow = true
      this.isShowPetList = true
      this.activeName = '0'
      this.handleClickPetTab()
    },
    async tryToFetchPetList() {
      this.petList = await this.$store.dispatch('member/fetchPetList', {
        memberId: this.memberInfo.id,
      })
    },
    /**
     * @description 取得寵物資料細節
     */
    goToPetInfoDetail(val) {
      this.petInfoActiveTab = val.alias
      this.closeAllInfo()
      this.petShow = true
      this.isShowPetList = val.isShowPetList
    },
    /**
     * @description 點選寵物列表後，獲取寵物細節
     */
    selectedPetInfo(val) {
      this.thisTimeSelectedPetInfo = val
    },
    /************ 寵物資訊相關 end ************/

    /************ 編輯客戶資訊相關 start ************/
    closeEditMemberForm() {
      this.visibleMemberDetailEdit = false
    },
    /**
     * @description 搜尋會員id，點會員下去的瞬間
     * @param {*String} memberId
     */
    async tryToFetchDetail(memberId) {
      this.tryingGetMember = true
      await this.tryToFetchMemberInfo(memberId) // 找出會員資訊
      this.closeEditMemberForm()
      this.visibleMemberSearch = false
      this.tryingGetMember = false
      this.tryToFetchPetList() // 寵物要找到會員才能搜尋
    },
    /**
     * @description 找出此會員資料
     */
    async tryToFetchMemberInfo(memberId) {
      this.memberInfo = await this.$store.dispatch('member/fetchSingle', { memberId })
    },
    updateUserByMember() {
      const fields = ['memberId', 'fullName', 'gender', 'phoneCode', 'phoneNumber', 'email']
      fields.forEach((field) => {
        this.submitData[field] = field === 'memberId' ? this.memberInfo.id : this.memberInfo[field]
      })
    },
    /************ 編輯客戶資訊相關 end ************/

    /************ 客戶資訊相關 start ************/
    closeMemberInfo() {
      this.memberInfoShow = false
    },
    goToMemberInfoDetail(val) {
      this.closeAllInfo()
      this.memberInfoShow = true
      this.memberInfoActiveTab = val
    },
    /************ 客戶資訊相關 end ************/

    /************ 選擇服務相關 start ************/
    closeService() {
      if (!this.currentService?.id && !this.isModified) {
        this.serviceType = ''
      }
      if (this.submitData.prepaidOrderUuid && !!this.currentService?.id) {
        this.serviceType = 'prepaid-order'
      }
      this.serviceShow = false
      this.scrollToBottom()
    },
    /**
     * @description 決定指定、不指定狀態
     */
    decideRadioDisableAndValue(isScheduleItemPrice) {
      if (isScheduleItemPrice === 'scheduleItemPrice') {
        this.staffSpecify = 'specify'
        this.isUseStaffPriceAdj = true
      } else {
        this.isUseStaffPriceAdj = false
      }
    },
    /**
     * @description 選到服務
     * 判斷如果數量為0 or undefined，就return 不讓使用者繼續點選
     */
    selectService(item) {
      const { qty, isScheduleItemPrice } = item

      if (qty === 0 || qty === undefined) {
        this.submitData.params = [paramsItem()]
        return
      }

      this.decideRadioDisableAndValue(isScheduleItemPrice)
      // this.resetService()
      // this.submitData.params = [this.setParams(item, 'service')]
      const arr = this.submitData.params.filter((obj) => obj.priceId)
      const service = this.setParams(item, 'service')

      if (arr.length === 0) {
        arr.push(service)
      } else {
        const index = arr.findIndex((obj) => obj.priceId === service.priceId)
        index === -1 ? arr.push(service) : this.$set(arr, index, service)
      }

      this.submitData.params = arr
      this.currentService = item
      this.currentServiceCont = []
      this.submitData.params.forEach((obj) => {
        this.currentServiceCont.push(`服務項目：${obj.title}`)
      })
      this.isPrepaidAndTotalEdit = false
      this.scrollToBottom()
    },
    previousFun() {
      this.overTimeReserveWindowStatus = false
    },
    /**
     * @description 驗證是否超出營業時間[婚紗會解開]
     */
    testOverTime() {
      try {
        const addMinute = this.currentService.serviceTime * this.currentService.qty
        if (this.isEndTimeOverDay(this.serviceTimeSetting, this.scheduleDetail.date, addMinute)) {
          return true
        } else {
          return false
        }
      } catch (error) {
        console.error(error.message)
      }
    },

    /**
     * @description 設定params
     */
    setParams(item, moreType = '') {
      const { type, title, price, id, qty, serviceTime, bufferTime } = item
      return {
        type: type ?? 'cosmetic', // 如果type undefined -> 則設定type = cosmetic
        title,
        price,
        priceId: id,
        qty: qty ?? 1, // 如果qty undefined -> 則設定qty = 1
        serviceTime,
        bufferTime,
        moreType,
      }
    },
    /************ 選擇服務相關 end ************/

    /************ 搜尋客戶方式相關 start ************/
    /**
     * @description 新增會員（抽屜右邊打開）
     */
    createMember(val) {
      if (this.isAutoOpen && this.drawerOpenType.autoOpenForGoodsAndNonMember) {
        this.addMemberStatus = false // 因為自動開啟，無法填寫電話，所以走這邊，要讓電話可以填
        this.memberInfo = { ...val }
        this.visibleMemberDetailEdit = true
        return
      }

      if (!this.isAutoOpen) {
        this.addMemberStatus = true
        this.memberInfo = { ...val }
        this.visibleMemberDetailEdit = true
      }
    },
    /**
     * @description 當使用者按下取消 or 儲存新會員成功之後，要將disable拔掉
     */
    releaseMemberPhoneDisable() {
      this.addMemberStatus = false // 目前視窗不是新增會員的狀態
    },
    /**
     * @description 有會員之後的重新搜尋
     */
    clearMemberInfo() {
      const memberStatus = this.drawerOpenType.autoOpenForGoodsAndMember || this.drawerOpenType.autoOpenForGoodsAndNonMember || this.drawerOpenType.autoOpenForGoodsAndVisit
      // 自動開啟 && member正在開啟
      if (this.isAutoOpen && memberStatus) {
        this.memberInfo = {}
        this.setAutoOpenType()
        this.visibleMemberSearch = true
        this.showGoodsList = false
        this.$set(this.drawerOpenType, 'autoOpenForGoodsAndMember', false)
        this.$set(this.drawerOpenType, 'autoOpenForGoodsAndNonMember', true)
        this.$set(this.drawerOpenType, 'autoOpenForGoodsAndVisit', false)
        this.$set(this.drawerOpenType, 'normal', false)
        return
      }
      // 沒有自動開啟 && 一般模式
      if (!this.isAutoOpen && this.drawerOpenType.normal) {
        this.closeLayout()
        this.memberInfo = {}
        this.submitData.petId = ''
        this.resetService()
        this.visibleMemberSearch = true
      }
    },
    /************ 搜尋客戶方式相關 end ************/

    /************ 加購相關 start ************/
    onSubmitAddition(list) {
      const formattedList = list.map((item) => ({
        type: 'cosmetic-add',
        title: item.title,
        priceId: item.thisOrderServiceId,
        price: item.price,
        qty: item.qty,
      }))
      this.submitData.params.push(...formattedList)
      this.prepaidAndEdit()
    },
    /************ 加購相關 end ************/

    /************ 變價相關 start ************/
    onSubmitTotalEdit(item) {
      this.submitData.params.push({ ...item })
    },
    clearParams() {
      this.submitData.params = this.submitData.params.filter(({ type }) => !['cosmetic-add', '+', '-', '%'].includes(type))
    },
    /************ 變價相關 end ************/
    onUpdateTotalStatement({ params, deleteIds }) {
      this.clearParams()
      this.submitData.params = [...this.submitData.params, ...params]
    },
    /**
     * @description 購買包月的總價
     */
    formatMemberLevelPrepaidPrice() {
      try {
        if (this.memberInfo.level) {
          const { prepaids } = this.memberInfo.level
          const index = prepaids.findIndex((prepaidItem) => prepaidItem.id === this.submitDataPrepaid.prepaidId)
          // 如果有會員折扣走這邊
          if (index > -1) {
            return this.composeTotalForDiscountObj({
              price: this.submitDataPrepaid.price,
              discountType: prepaids[index]['discountType'],
              discount: prepaids[index]['discount'],
            })
          } else {
            // 如果沒有折扣走這邊，直接給包月的價錢
            return this.submitDataPrepaid.price
          }
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 更新submitData內的params
     */
    updateSubmitDataParams(item) {
      if (Object.keys(item).length > 0) {
        this.tempUpdateParams = item
      }
    },
    closeExtraDialogVisible() {
      this.extraDialogVisible = false
      this.emitStore()
    },
    // 載入商品訂單
    async loadGoodsOrder() {
      if (this.goodsOrderId !== '') {
        this.goodsOrderData = await this.$store.dispatch('order/fetchSingle', this.goodsOrderId)
      }
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.autoOpenForGoodsAndNonMemberClass {
  height: 50vh !important;
}

.autoOpenForGoodsAndMemberClass {
  height: 90vh !important;
}

.autoOpenForGoodsAndVisitClass {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 80vh !important;
  padding-bottom: 10px !important;

  :global {
    .el-button {
      width: 90%;
    }
  }
}

.orderformSection {
  height: 100%;

  :global {
    .form-block-title {
      font-size: 16px;
      padding-bottom: 0;
      margin-top: 0;
    }

    .mb-5 {
      margin-top: 5px;
    }

    .info-section {
      padding: 30px 40px;

      @include max-lg {
        padding: 15px 20px;
      }
    }

    .orderformSection {
      &__all {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        height: 100vh;
        position: relative;
      }

      &__beforeTotalAllShowRight {
        color: red;
        opacity: 0.5;
        width: 57%;
        border-right: $color-border-base 1px solid;
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        background: transparent !important;
      }

      &__beforeTotalAllShowLeft {
        color: blue;

        &__box {
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 100%;
          padding: 20px;
          overflow-y: auto;

          > div > p {
            font-size: 16px;
            color: $color-secondary;
          }
        }

        &__moreMargin {
          margin-bottom: 50px;
        }

        &__info {
          display: flex;
          flex-direction: column;
          padding: 16px 18px;
          width: 100%;
          background-color: white;
          border-radius: $border-radius;
          border: 1px solid $color-border-base;

          > div {
            display: flex;
          }

          > div:nth-child(1) {
            margin-bottom: 6px;
          }

          > div:nth-child(2) {
            margin-bottom: 10px;
          }

          p {
            color: $color-secondary;
            margin: 0;
            margin-right: 8px;
            letter-spacing: 1.92px;
          }

          span {
            color: $color-text-light;
          }

          :global {
            .el-button {
              span {
                color: white;
              }
            }
          }
        }
      }

      &__mask {
        position: absolute;
        z-index: 100000;
        right: 0;
        width: 57%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        > div:nth-child(1) {
          color: white;
          position: absolute;
          z-index: 2;
          font-size: 20px;
        }

        > div:nth-child(2) {
          background: rgba(0, 0, 0, 0.4);
          width: 100%;
          height: 100%;
          right: 0;
          z-index: 1;
          backdrop-filter: blur(5px);
          position: absolute;
        }
      }

      &__left {
        width: 57%;
        border-right: $color-border-base 1px solid;
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        background: $color-line;

        &__content {
          height: 100vh;
          overflow: auto;
          padding-bottom: 90px;

          &__bg {
            background-color: white;
            padding: 18px;
            margin-bottom: 10px;
          }

          &__tab {
            p {
              font-size: 20px;
            }

            :global {
              .el-tabs__header {
                margin: 0;
              }

              .el-tabs__nav-scroll {
                background-color: white;
                height: 92px;

                :global {
                  .el-tabs__item {
                    height: 90px;
                    width: 110px;
                    padding: 0;
                    background-color: #f2f2f2;
                    color: #121931;
                    opacity: 0.5;

                    &.is-active {
                      background-color: white;
                      border-left: 1px solid #f2f2f2;
                      border-right: 1px solid #f2f2f2;
                      border-top: 2px solid $color-primary;
                      border-bottom: 1px solid #f2f2f2;
                      color: $color-primary;
                      opacity: 1;
                    }
                  }
                }
              }

              .tabHeader {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                padding-top: 15px;
              }

              .el-tabs__nav-wrap {
                display: flex;
                align-items: center;

                > span {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background-color: white;
                  height: 100%;
                  width: 44px;

                  > i {
                    color: black;
                  }
                }
              }
            }
          }

          &__tabMorePadding {
            :global {
              .el-tabs__nav-wrap {
                padding-left: 44px;
                padding-right: 44px;
              }
            }
          }

          &__time {
            display: flex;
            justify-content: space-between;
          }

          &__timeMain {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 142px;
            height: 35px;
            background-color: #f8e0e2;
            color: red;
            border-radius: $border-radius;
          }
        }
      }

      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;
        background: $color-line;

        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }

        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;

          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }

          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__header {
            margin-bottom: 0;
          }

          .el-tabs--top {
            margin-left: 60px;
          }
        }

        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;
        }
      }

      &__info {
        position: relative;
        width: 100%;
        height: calc(100vh);
        overflow: hidden;
        background: $color-line;

        .orderformSection__info__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }

        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;

          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }

          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__header {
            margin-bottom: 0;
          }

          .el-tabs--top {
            margin-left: 60px;
          }
        }
      }

      &__bottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        background: #fff;
        box-shadow: 0 -5px 5px rgba(#eee, 0.3);
        z-index: 999;

        @include touch {
          position: static;
        }

        &__btn {
          width: 40%;
        }

        &__btn-item {
          min-width: 132px;
        }

        &__qBtn {
          width: 17%;
        }

        &__serviceBtn {
          width: 192px;
        }

        &__completeBtn {
          width: 192px;
        }

        &__payImmediate {
          width: 192px;
          margin-left: 15px;
        }

        &__right {
          flex-grow: 1;
          display: flex;
          justify-content: flex-end;
        }

        &__autoOpenNonMember {
          &__title {
            font-size: 16px;
            color: $color-secondary;
            margin-top: 0;
            margin-bottom: 5px;
            font-weight: 600;
          }

          &__text {
            font-size: 12px;
            color: $color-text-light;
            margin-top: 0;
            margin-bottom: 0;
          }
        }
      }
    }

    .viewList {
      &__item {
        flex-grow: 1;
        font-size: 0.75rem;

        svg {
          font-size: 1.25rem;
          color: $color-primary;
          vertical-align: text-top;
        }

        &:not(:last-child) {
          position: relative;

          &:before {
            content: '';
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            height: 50%;
            width: 1px;
            background: #e5e7eb;
          }
        }
      }
    }

    .currentServiceCont {
      .el-button {
        &.isActive {
          position: relative;

          &.ishasCurrentServiceCont {
            &:before {
              content: '';
              position: absolute;
              width: 0;
              height: 0;
              left: 50%;
              transform: translateX(-50%);
              right: 0;
              bottom: -11px;
              border-style: solid;
              border-width: 12px 18px 0 18px;
              border-color: $color-primary transparent transparent transparent;
            }
          }
        }
      }

      .currentServiceContItem {
        padding: 1.25rem;
        background: $color-line;
        border-radius: 8px;

        .text {
          color: $color-secondary;
        }
      }

      .currentServiceContItemOri {
        padding: 1.25rem;
        background: $color-line-dark;
        border-radius: 8px;
        margin-top: 5px;

        .text {
          color: $color-secondary;
        }

        > div {
          color: $color-primary;
        }
      }
    }
  }
}

.editOneLine {
  display: flex;
  align-items: center;
  position: relative;
  flex-wrap: wrap;

  :global {
    .el-form-item__error {
      position: static;
      width: 100%;
      padding-left: 80px;
    }

    .editOneLine {
      &__title {
        margin: 0;
        font-size: 14px;
        color: #6c6c6b;
      }

      &__text {
        font-size: 14px;
        margin-right: 15px;
      }
    }

    .el-form-item {
      margin-bottom: 0;
      margin-right: 15px;

      &.isFull {
        margin-bottom: 20px;
      }
    }

    .el-input__inner {
      background-color: #fff;
      height: 40px;
    }
  }
}

.visitHeader {
  margin-top: 0px;
  padding: 20px 30px 5px;
  border-bottom: $color-border-base 1px solid;

  @include max-lg {
    padding-right: 20px;
  }

  :global {
    h5 {
      font-size: 18px;
    }
  }
}

.header {
  margin-top: 5px;
  padding-right: 40px;
  padding-left: 60px;
  padding-bottom: 10px;
  border-bottom: $color-border-base 1px solid;

  @include max-lg {
    padding-right: 20px;
  }

  :global {
    h5 {
      font-size: 18px;
    }
  }
}

.fakeHeader {
  margin-top: 50%;
  padding-right: 40px;
  padding-left: 60px;
  padding-bottom: 10px;

  @include max-lg {
    padding-right: 20px;
  }

  :global {
    h5 {
      font-size: 18px;
    }
  }
}

.fakeHeaderForMember {
  margin-top: 5%;
  padding-right: 40px;
  padding-left: 60px;
  padding-bottom: 10px;

  @include max-lg {
    padding-right: 20px;
  }

  :global {
    h5 {
      font-size: 18px;
    }
  }
}

.title:not(:first-child) {
  margin-top: 18px;
}

.total {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 1;

  @include touch {
    position: static;
  }

  :global {
    .total {
      &__cont {
        height: calc(100% - 70px);

        @include touch {
          height: auto;
        }
      }

      &__bottom {
        padding: 30px 30px;
        position: absolute;
        bottom: 80px;
        width: 100%;
        border-top: $color-border-base 1px solid;

        h6 {
          margin-top: 0;
        }
      }
    }
  }
}

.categoryList {
  top: 50px !important;
}

.goodsListHeader {
  top: 75px !important;
}

.bottom {
  /* position: absolute;
  bottom: 0; */
  width: 100%;
  padding: 0 30px 0;

  @include touch {
    position: static;
  }
}

.nameSpecifyDisplay {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.payListF {
  :global {
    .el-drawer__close-btn {
      display: none !important;
    }
  }
}

.serviceCollapse {
  padding: 1.25rem;
  background: $color-line-dark;
  border-radius: 8px;
  margin-top: 5px;

  &__context {
    display: flex;
    flex-direction: column;

    > div:nth-child(1) {
      color: $color-primary;
    }

    :global {
      .text {
        color: $color-secondary;
      }
    }
  }

  &__detail {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  &__member {
    display: flex;
    flex-direction: column;

    & > p {
      margin-top: 0;

      > span {
        color: $color-secondary;
      }
    }
  }
}

.productPlacement {
  z-index: 100;

  :global {
    .el-input__inner {
      height: $tabs-item--header-height;
      border-radius: 0;
      border: 0;
      color: white;
      font-size: 16px;

      &::placeholder {
        color: white;
        opacity: 1;
      }
    }

    .el-input__icon {
      color: white;
    }
  }

  @include pad {
    top: 0;
  }
}
</style>
